{
  "setupCheck": {
    "button": "Configuration",
    "title": "Configuration",
    "count": "{n} à régler",
    "progress": "{ok} sur {total} en ordre",
    "ok": "En ordre",
    "titles": {
      "contact_email_missing": "Courriel de contact",
      "tax_number_missing": "Numéros d'inscription des taxes",
      "hq_unlocated": "Siège social",
      "no_job_types": "Types de job",
      "type_without_crew": "Équipes par type",
      "season_never_opened": "Ouverture des saisons",
      "no_work_crew": "Équipe de travaux",
      "no_quote_crew": "Équipe de soumissions",
      "invitations_pending": "Invitations",
      "crew_without_member": "Membres des équipes",
      "crew_without_type": "Types des équipes",
      "crew_without_target": "Objectifs du jour",
      "technician_without_app": "Application mobile"
    },
    "lines": {
      "contact_email_missing": "Aucun courriel de contact",
      "tax_number_missing": "Taxe facturée sans numéro d'inscription",
      "hq_unlocated": "Siège non localisé",
      "no_job_types": "Aucun type de job",
      "type_without_crew": "Type sans équipe",
      "season_never_opened": "Saison jamais ouverte, des jobs attendent",
      "no_work_crew": "Aucune équipe de travaux",
      "no_quote_crew": "Aucune équipe de soumissions",
      "invitations_pending": "Invitation en attente",
      "crew_without_member": "Équipe sans membre",
      "crew_without_type": "Équipe sans type",
      "crew_without_target": "Équipe sans objectif du jour",
      "technician_without_app": "Technicien sans application"
    }
  },
  "units": {
    "ea": "ch.",
    "hr": "h",
    "day": "j",
    "ft": "pi",
    "m": "m",
    "sqft": "pi²",
    "sqm": "m²",
    "lb": "lb",
    "kg": "kg",
    "lot": "forfait"
  },
  "auth": {
    "login": "Connexion",
    "logout": "Déconnexion",
    "email": "Adresse courriel",
    "password": "Mot de passe",
    "passwordConfirmation": "Confirmer le mot de passe",
    "signIn": "Se connecter",
    "oauthFailed": "La connexion externe n'a pas abouti. Réessayez ou utilisez votre courriel.",
    "rememberMe": "Se souvenir de moi",
    "loginFailed": "Échec de la connexion",
    "emailPlaceholder": "Entrez votre courriel",
    "passwordPlaceholder": "Entrez votre mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "forgotPasswordTitle": "Réinitialiser votre mot de passe",
    "forgotPasswordHint": "Entrez le courriel de votre compte — nous vous enverrons un lien de réinitialisation.",
    "sendResetLink": "Envoyer le lien",
    "resetEmailSent": "Si un compte existe pour {email}, un lien de réinitialisation est en route. Vérifiez votre boîte de réception.",
    "backToLogin": "Retour à la connexion",
    "resetPasswordTitle": "Choisir un nouveau mot de passe",
    "resetPasswordHint": "Choisissez un nouveau mot de passe pour votre compte.",
    "resetPasswordAction": "Changer mon mot de passe",
    "resetSuccess": "Mot de passe modifié — connectez-vous avec le nouveau.",
    "resetTokenMissing": "Ce lien de réinitialisation est invalide — demandez-en un nouveau.",
    "placeholders": {
      "password": "Au moins 8 caractères",
      "passwordConfirmation": "Répétez votre mot de passe"
    },
    "validation": {
      "passwordMin": "Le mot de passe doit contenir au moins 8 caractères",
      "passwordMatch": "Les deux mots de passe ne correspondent pas"
    }
  },
  "dashboard": {
    "loading": "Chargement...",
    "fieldDayCount": "1 arrêt aujourd'hui, il en reste {left} | {count} arrêts aujourd'hui, il en reste {left}",
    "fieldDayEmpty": "Aucun arrêt aujourd'hui.",
    "stats": {
      "completedToday": "Faites aujourd'hui",
      "remaining": "Restantes"
    },
    "blockers": "Ce qui bloque"
  },
  "profile": {
    "updateSuccess": "Profil mis à jour avec succès.",
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom"
    },
    "placeholders": {
      "firstName": "Jeanne",
      "lastName": "Tremblay"
    },
    "avatar": {
      "instructions": "Cliquez ou glissez une image ici pour modifier votre avatar.",
      "errorImageOnly": "Veuillez sélectionner un fichier image valide."
    }
  },
  "timeZones": {
    "newfoundland": "Heure de Terre-Neuve",
    "atlantic": "Heure de l'Atlantique",
    "eastern": "Heure de l'Est",
    "central": "Heure du Centre",
    "saskatchewan": "Saskatchewan (sans heure avancée)",
    "mountain": "Heure des Rocheuses",
    "pacific": "Heure du Pacifique",
    "utc": "UTC"
  },
  "organizations": {
    "select": "Sélectionner une organisation",
    "choose": "Choisissez l'organisation à laquelle vous souhaitez accéder :",
    "noneFound": "Aucune organisation trouvée.",
    "welcome": "Bienvenue",
    "pickToBegin": "Choisissez votre organisation pour commencer.",
    "createNew": "Ou créez-en une nouvelle :",
    "createDescription": "Établissez un nouvel espace de travail pour votre équipe.",
    "current": "Organisation actuelle : {name}",
    "settings": "Paramètres de l'organisation",
    "switch": "Changer d'organisation",
    "updateSuccess": "Organisation mise à jour avec succès.",
    "fields": {
      "name": "Nom de l'organisation",
      "billingEmail": "Courriel du compte Stripe",
      "timeZone": "Fuseau horaire",
      "hqAddress": "Adresse du siège",
      "businessAddress": "Adresse imprimée sur vos documents",
      "maxServiceTravelMinutes": "Trajet max depuis le siège (min)",
      "publicTagline": "Sous-titre",
      "rbqLicence": "Licence RBQ",
      "publicPhone": "Téléphone public",
      "publicEmail": "Courriel public"
    }
  },
  "sectors": {
    "title": "Secteurs",
    "served": "Municipalités desservies",
    "addNew": "Ajouter une municipalité",
    "add": "Ajouter | Ajouter {n} municipalité | Ajouter {n} municipalités",
    "none": "Sans secteur",
    "empty": "Aucune municipalité",
    "emptyHint": "Ajoutez les municipalités que vous desservez.",
    "fields": {
      "name": "Nom"
    },
    "locationsCount": "aucun emplacement | {n} emplacement | {n} emplacements",
    "unserved": "Travail en attente hors de vos municipalités :",
    "reset": {
      "action": "Réinitialiser selon le trajet",
      "confirmTitle": "Réinitialiser selon le trajet ?",
      "confirmDescription": "{added} · {removed}. Les emplacements des municipalités retirées restent, sans secteur.",
      "added": "aucune ajoutée | {n} ajoutée | {n} ajoutées",
      "removed": "aucune retirée | {n} retirée | {n} retirées",
      "summary": "{added} · {removed}",
      "upToDate": "La liste correspond déjà au trajet.",
      "unavailable": "Les temps de route sont indisponibles pour l'instant — réessayez sous peu."
    },
    "alreadyAdopted": "Déjà desservie",
    "searchCatalog": "Parcourir ou rechercher le catalogue officiel",
    "searchCatalogPlaceholder": "Filtrer par nom — ex. Lévis",
    "noResults": "Aucune municipalité trouvée.",
    "level": {
      "municipality": "Municipalité",
      "arrondissement": "Arrondissement"
    },
    "viewMap": "Voir la zone sur une carte",
    "deleteConfirmTitle": "Retirer cette municipalité ?",
    "deleteConfirmDescription": "Les emplacements de « {name} » restent, sans secteur.",
    "createSuccess": "Municipalité ajoutée.",
    "batchAdoptSuccess": "Aucune nouvelle municipalité (toutes déjà en place). | {n} municipalité ajoutée. | {n} municipalités ajoutées.",
    "deleteSuccess": "Municipalité retirée.",
    "filterPlaceholder": "Filtrer par secteur"
  },
  "serviceArea": {
    "outside": "Hors zone (~{minutes} min)",
    "outsideNoEstimate": "Hors zone de service",
    "fromHq": "~{minutes} min du garage",
    "hint": "Hors de la zone de service de l'organisation — informatif seulement, jamais bloquant"
  },
  "fieldBank": {
    "title": "Banque de jobs",
    "pullButton": "Piger dans la banque",
    "pullSuccess": "Job ajoutée à votre journée | Job ajoutée à votre journée | {count} jobs ajoutées à votre journée",
    "pullPartial": "{count} ajoutées · {dropped} étaient déjà prises",
    "pull": "Piger",
    "empty": "Aucune job flexible en attente dans la banque.",
    "emptyBorrow": "Rien à devancer pour les types de votre journée.",
    "searchPlaceholder": "Rechercher un client",
    "forCrew": "pour {name}",
    "filters": {
      "types": "Types",
      "sector": "Secteur"
    },
    "untitled": "Visite sans titre",
    "untyped": "Type à définir",
    "lens": {
      "capability": "Ma capacité",
      "all": "Tout",
      "untyped": "Sans type"
    },
    "views": {
      "bank": "Banque",
      "other": "À devancer"
    },
    "plannedOn": "Prévu le {date}",
    "detour": "+{minutes} min",
    "bestAdd": "Meilleur ajout",
    "fill": "Remplir le reste de la journée",
    "fillNoBudget": "Aucune cible pour la journée — sans elle, le remplissage ne sait pas où s'arrêter.",
    "fillNothing": "Rien dans la banque n'entre dans ce qu'il reste.",
    "crewPicker": {
      "title": "Vous démarrez la journée de quelle équipe ?",
      "hint": "Vous êtes dans plus d'une équipe, et aucune n'a encore de journée confirmée."
    },
    "gauge": {
      "remaining": "Reste {amount}",
      "over": "Dépassement de {amount}"
    },
    "noCrew": "Vous n'êtes dans aucune équipe, il n'y a donc pas de journée où piger. Voyez avec la répartition.",
    "returnToBank": "Remettre dans la banque",
    "returnToBankConfirm": "Remettre",
    "returnedToBank": "De retour dans la banque — toujours dû, mais pas aujourd’hui"
  },
  "dayPlan": {
    "title": "Ma journée",
    "summaryStops": "1 arrêt | {count} arrêts",
    "summaryDone": "{count} fait | {count} fait | {count} faits",
    "summaryLeft": "{count} restant | {count} restant | {count} restants",
    "dayOffHint": "les arrêts ci-dessous ne sont pas encore réglés"
  },
  "contacts": {
    "title": "Contacts",
    "createNew": "Nouveau contact",
    "createNamed": "Créer « {name} »",
    "editTitle": "Modifier le contact",
    "createSuccess": "Contact créé avec succès.",
    "updateSuccess": "Contact mis à jour avec succès.",
    "deleteSuccess": "Contact supprimé.",
    "deleteConfirmTitle": "Supprimer le contact ?",
    "deleteConfirmDescription": "Êtes-vous sûr de vouloir supprimer {name} ? Cette action est irréversible.",
    "noContacts": "Aucun contact trouvé.",
    "search": "Rechercher des contacts",
    "searchPlaceholder": "Rechercher des contacts",
    "deleteTitle": "Supprimer le client",
    "fields": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Adresse courriel",
      "phone": "Téléphone",
      "cellPhone": "Cellulaire (textos)",
      "noSms": "Aucun contact SMS",
      "jobTitle": "Fonction",
      "fullName": "Nom complet",
      "company": "Entreprise",
      "created": "Créé"
    },
    "siteContactRole": "Personne-ressource",
    "detailsTitle": "Coordonnées"
  },
  "companies": {
    "title": "Entreprises",
    "createNew": "Nouvelle entreprise",
    "editTitle": "Modifier l'entreprise",
    "createSuccess": "Entreprise créée avec succès.",
    "updateSuccess": "Entreprise mise à jour avec succès.",
    "deleteSuccess": "Entreprise supprimée.",
    "deleteConfirmTitle": "Supprimer l'entreprise ?",
    "deleteConfirmDescription": "Êtes-vous sûr de vouloir supprimer {name} ? Les contacts associés seront dissociés et les adresses de service seront supprimées.",
    "noCompanies": "Aucune entreprise trouvée.",
    "searchPlaceholder": "Rechercher des entreprises",
    "people": {
      "title": "Contacts",
      "empty": "Aucun contact lié à cette entreprise.",
      "link": "Lier un contact",
      "unlink": "Dissocier"
    },
    "fields": {
      "companyName": "Nom de l'entreprise",
      "email": "Adresse courriel",
      "phone": "Téléphone",
      "website": "Site web",
      "notes": "Notes",
      "created": "Créée"
    },
    "detailsTitle": "Coordonnées",
    "deleteTitle": "Supprimer l’entreprise"
  },
  "visits": {
    "title": "Visites",
    "nextVisit": "Votre prochaine visite",
    "todayList": "Arrêts du jour",
    "emptyTodayTitle": "Aucune visite aujourd'hui",
    "visitN": "Visite {position}",
    "visitOfTotal": "Visite {index} de {total}",
    "addVisit": "Ajouter une visite",
    "removeVisit": "Supprimer la visite",
    "removeConfirm": "Supprimer cette visite ? Cette action est irréversible.",
    "lastVisitGuard": "Un travail doit conserver au moins une visite.",
    "unscheduled": "Non planifiée",
    "flexibleUnscheduled": "Flexible — sans promesse d’heure, attend en banque",
    "toPlace": "À placer",
    "chip": {
      "bank": "En banque",
      "after": "Après {title}",
      "previousStep": "l'étape précédente",
      "toConfirm": "À contacter"
    },
    "giveDate": "Donner une date",
    "minutes": "{n} min",
    "markDone": {
      "action": "Marquer faite",
      "title": "Marquer comme faite",
      "on": "Quand",
      "crew": "Par",
      "noCrewHint": "Sans équipe, la journée n'est créditée à personne.",
      "submit": "Marquer faite"
    },
    "ladder": {
      "otherDayWarning": "Cette visite est prévue le {date}, pas aujourd'hui."
    },
    "sections": {
      "evaluation": "Évaluation",
      "work": "Travaux"
    },
    "createSuccess": "Visite créée.",
    "updateSuccess": "Visite mise à jour.",
    "confirmSuccess": "Visite confirmée — en attente d’une date.",
    "unconfirmSuccess": "Entente retirée.",
    "deleteSuccess": "Visite supprimée.",
    "statusUpdated": "Statut de la visite mis à jour.",
    "status": {
      "pending": "En attente",
      "scheduled": "Planifiée",
      "dispatched": "Répartie",
      "working": "En cours",
      "completed": "Terminée",
      "skipped": "Ignorée",
      "cancelled": "Annulée"
    },
    "extra": {
      "badge": "Hors programme",
      "menuTitle": "Modèles — {type}",
      "free": "Visite libre",
      "presetHint": "{name} · préremplie par le modèle du type — tout reste modifiable",
      "when": "Quand",
      "whenPlace": "À placer",
      "whenDate": "Choisir une date",
      "dueWithinShort": "d'ici {days} j",
      "submit": "Ajouter la visite"
    },
    "fields": {
      "name": "Nom",
      "namePlaceholder": "ex. Premier traitement (optionnel)",
      "instructions": "Consignes pour l'équipe",
      "instructionsPlaceholder": "Ce que le client a signalé, ce qu'il faut reprendre, quand il est là",
      "instructionsHint": "S'affiche sur l'arrêt, au téléphone. Jamais copié depuis le modèle.",
      "dueWithin": "À faire d'ici",
      "dueWithinHint": "La banque et le tableau placent d'abord ce qui est dû.",
      "scheduledAt": "Heure planifiée",
      "duration": "Durée",
      "durationMinutes": "Durée (minutes)",
      "status": "Statut"
    },
    "window": {
      "section": "Fenêtre de retraitement",
      "sectionHint": "Quand cette visite devient due, calculée à partir de la visite précédente.",
      "firm": "Fenêtre confirmée",
      "projected": "Fenêtre projetée",
      "overdue": "En retard",
      "dueRange": "Dû {range}",
      "dueBy": "Dû d'ici {date}",
      "dueOn": "Dû {date}",
      "overdueRange": "En retard · {range}"
    },
    "deferredFrom": "Retour du {date}",
    "deferredHint": "Retournée à la banque à la clôture de sa journée — toujours à faire.",
    "reservedFor": "Prévu pour {name}",
    "reservedForHint": "Une équipe a été nommée sur cette visite — aucune sélection automatique ne la donnera à une autre. Vous pouvez toujours la confier à qui dépanne.",
    "deferredStartedHint": "Commencée, jamais terminée — retournée à la banque à la clôture de sa journée.",
    "draftPlacement": "Brouillon · {crew} · {date}",
    "draftPlacementHint": "Déjà déposée sur une journée en brouillon — confirmez-la ou retirez-la avant de la placer ailleurs.",
    "flexible": {
      "label": "Horaire flexible",
      "hint": "Sans promesse d'heure — le client ne s'attend pas à un appel sur le moment de l'intervention.",
      "badge": "Sans promesse d'heure"
    },
    "kind": {
      "work": "Travail",
      "evaluation": "Évaluation",
      "evaluationHint": "Un repérage de vente — jamais compté comme valeur de travail; la compléter marque le dossier évalué."
    },
    "actions": {
      "dispatch": "Répartir",
      "startWork": "Commencer",
      "complete": "Terminer",
      "completeEvaluation": "Terminer l’évaluation",
      "finishVisit": "Terminer la visite",
      "skip": "Ignorer",
      "confirm": "Mettre en banque",
      "unconfirm": "Retirer de la banque",
      "cancel": "Annuler"
    },
    "timeline": {
      "added": "Visite {position} ajoutée",
      "removed": "Visite {position} supprimée",
      "statusChanged": "Visite {position} → {to}",
      "assigned": "{name} assigné à la visite {position} comme {kind}",
      "unassigned": "{name} retiré de la visite {position}",
      "squadAssigned": "Équipe « {name} » assignée à la visite {position}",
      "bankPulled": "Pigée dans la banque",
      "bankPulledOn": "Pigée dans la banque pour le {date}",
      "crewStamped": "Équipe « {name} » consignée sur la visite {position} (travail démarré)",
      "crewStampedSelf": "Technicien consigné sur la visite {position} (travail démarré)"
    },
    "confirmActionDescription": "Confirmer que vous voulez {action} pour cette visite.",
    "seasonLapsed": "Saison terminée",
    "seasonLapsedHint": "Ces travaux étaient dus dans une saison maintenant terminée. Ils restent dus, mais le composeur ne les place plus et ils ne comptent plus comme en retard.",
    "composeWindow": {
      "waiting": "Pas encore",
      "passed": "Fenêtre terminée",
      "waitingHint": "La période de son type de job n'a pas commencé : le composeur et les remplissages ne le proposent pas encore. Il se place à la main.",
      "passedHint": "La période de son type de job est terminée : le composeur et les remplissages ne le proposent plus. Toujours dû, il se place à la main."
    },
    "face": {
      "saved": "Enregistré · {field}",
      "notSaved": "Non enregistré — vérifiez la valeur",
      "durationOther": "autre",
      "positiveMinutes": "Un nombre entier de minutes",
      "wholeDays": "Un nombre entier de jours",
      "intervalMin": "Au plus tôt (jours)",
      "intervalMax": "Au plus tard (jours)",
      "crew": "Équipe",
      "instructions": "Consignes",
      "delay": "Délai",
      "daysAfter": "jours après {title}",
      "previousVisit": "la visite précédente",
      "between": "entre le {from} et le {to}",
      "from": "à partir du {date}",
      "until": "d'ici le {date}",
      "byHand": "fixé à la main",
      "recompute": "Recalculer"
    },
    "door": {
      "changeDate": "Changer la date",
      "backToBank": "Remettre en banque",
      "seeBoard": "Voir sur le tableau",
      "confirmedDay": "Sur une journée confirmée",
      "freeDay": "Pas sur une journée confirmée"
    },
    "retire": {
      "label": "Retirer la visite",
      "skip": "Pas nécessaire cette fois",
      "cancel": "Le client annule"
    },
    "awaiting": {
      "short": "En attente",
      "hint": "L'étape précédente du programme n'a pas encore de date. Le composeur ne place pas celle-ci avant."
    }
  },
  "jobs": {
    "title": "Travaux",
    "kind": "Rôle",
    "deleteSuccess": "Job supprimé.",
    "live": "En cours",
    "myJobs": "Mes travaux",
    "allJobs": "Tous les travaux",
    "nextJob": "Votre prochain travail",
    "urgentService": "Appel de service urgent",
    "emptyTitle": "Pas de travaux pour aujourd'hui",
    "serviceHistory": "Historique de service",
    "noHistory": "Aucun travail précédent trouvé pour ce client.",
    "createSuccess": "Travail créé avec succès.",
    "leadCreated": "Lead créé.",
    "createdToast": {
      "open": "Ouvrir le job",
      "dealConfirmed": "Vente confirmée.",
      "evaluationFirm": "Évaluation planifiée.",
      "evaluationBank": "Évaluation envoyée à la banque."
    },
    "statusUpdated": "Statut du travail mis à jour.",
    "noType": "Sans type",
    "typeUpdated": "Type de job mis à jour.",
    "planMultipleVisits": "Planifier plusieurs visites",
    "deleteConfirmTitle": "Supprimer le travail ?",
    "deleteConfirmDescription": "Cela annulera et supprimera définitivement ce dossier de travail.",
    "selectSquad": "Assigner une équipe (Optionnel)",
    "noSquad": "Aucune équipe (Assignation manuelle)",
    "status": {
      "title": "Statut",
      "open": "Ouvert",
      "assessed": "Évalué",
      "approved": "Approuvé",
      "completed": "Terminé",
      "invoiced": "Facturation en cours",
      "paid": "Payé",
      "cancelled": "Annulé",
      "lost": "Perdu"
    },
    "selectLocation": "Adresse de service",
    "locationStep": "Où se déroule le travail?",
    "fields": {
      "scheduledAt": "Heure planifiée",
      "scheduledFor": "Prévu pour",
      "customer": "Client",
      "unscheduled": "Non planifié",
      "scheduled": "Planifié",
      "created": "Créé",
      "title": "Titre",
      "description": "Description",
      "jobType": "Type de job",
      "dossier": "Dossier",
      "nextVisit": "Prochaine visite",
      "skipProposal": "Aucune soumission requise",
      "skipProposalHint": "Pour les rappels de garantie ou les travaux internes",
      "promisedWindow": "Fenêtre promise"
    },
    "timeline": {
      "title": "Historique",
      "noEvents": "Aucun événement enregistré.",
      "loadMore": "Charger plus",
      "system": "Système",
      "created": "Travail {ref} créé",
      "statusChanged": "Statut → {to}",
      "assigned": "{name} assigné en tant que {kind}",
      "unassigned": "{name} désassigné",
      "squadAssigned": "Équipe \"{name}\" assignée",
      "underpricedMarked": "Prix jugé trop bas pour ce travail",
      "underpricedCleared": "Marque « prix trop bas » retirée",
      "paymentFirstEnabled": "Paiement avant travaux activé",
      "paymentFirstDisabled": "Paiement avant travaux retiré",
      "createdGrouped": "Créé pour une soumission groupée",
      "createdGroupedPaper": "Créé pour la soumission {paper}",
      "createdForfait": "Créé pour le forfait « {offer} »",
      "createdForfaitPaper": "Créé pour le forfait {paper}",
      "createdRenewal": "Travail {ref} créé — renouvellement",
      "createdRenewalPaper": "Renouvelé avec le forfait {paper}",
      "createdRenewalOption": "Créé pour l'option {paper} du renouvellement",
      "createdFrom": "{label}, depuis {origin}",
      "renewed": "Renouvelé · {child}",
      "renewedPaper": "Renouvelé · {child} (forfait {paper})",
      "leftBehind": "Non renouvelé — {reason}",
      "leftBehindPaper": "Non renouvelé avec le forfait {paper} — {reason}",
      "leftBehindReason": {
        "dead": "Job fermé",
        "not_sold": "Jamais vendu",
        "declined_forever": "Plus jamais",
        "skip_proposal": "Vendu sans soumission",
        "renewed": "Déjà renouvelé",
        "declined_year": "Pas cette année",
        "type_unlinked": "Type retiré de la saison"
      },
      "declinedYear": "Pas en {season}",
      "declinedYearPlain": "Pas cette année",
      "declinedForever": "Plus jamais renouvelé",
      "declineUndoneYear": "Refus retiré — {season}",
      "declineUndoneYearPlain": "Refus retiré — pas cette année",
      "declineUndoneForever": "Refus retiré — plus jamais",
      "seeAll": "Tout voir"
    },
    "postits": {
      "jobNote": "Note du job",
      "empty": "Aucune note"
    },
    "actions": {
      "dispatch": "Répartir",
      "start": "Commencer le travail",
      "complete": "Terminer le travail",
      "lose": "Marquer comme perdu",
      "cancel": "Annuler le travail",
      "startNavigation": "Démarrer la navigation",
      "navigate": "Naviguer",
      "openJob": "Ouvrir le job",
      "viewReceipt": "Voir le reçu",
      "reschedule": "Reprogrammer",
      "unskipProposal": "Finalement, une soumission",
      "renew": "Renouveler"
    },
    "deals": {
      "section": "Dossiers ouverts",
      "stage": {
        "signed": "Signé",
        "pending": "En attente",
        "drafted": "Brouillon",
        "evaluated": "Évalué",
        "lead": "Lead"
      },
      "none": "Aucun dossier ouvert",
      "newJob": "Nouveau job",
      "acceptedProposal": "Soumission acceptée",
      "submitWin": "Confirmer les travaux",
      "submitAccept": "Accepter et réserver",
      "submitAcceptOnly": "Accepter la soumission",
      "paperUnpriced": "lignes sans prix",
      "pickPaper": "Quelle soumission le client a-t-il acceptée ?"
    },
    "agreement": {
      "section": "Combien ?",
      "template": "Soumission standard",
      "templateFor": "Soumission pour {type}",
      "templateNoType": "Aucun type de job choisi",
      "templateNone": "Aucune soumission standard définie",
      "templateNoneFor": "Aucune soumission standard pour {type}",
      "priced": "Montant convenu",
      "noProposal": "Sans soumission",
      "labelField": "Libellé",
      "amountField": "Montant avant taxes ($)",
      "taxableLabel": "Taxable (TPS/TVQ)",
      "descriptionField": "Description",
      "totalBeforeTax": "Total avant taxes",
      "amountRequired": "Entrez le montant convenu, ou choisissez « Sans soumission ».",
      "pickOffer": "Quelle soumission ?"
    },
    "cancelConfirmDescription": "Cela annulera le travail. Le dossier sera conservé pour référence.",
    "loseConfirmDescription": "Marquer ce travail comme perdu. Utilisez ceci lorsque le client a refusé la soumission et qu'aucun autre travail ne sera effectué.",
    "dispatchBoard": {
      "tabs": {
        "all": "Tous",
        "open": "Ouverts",
        "pipeline": "En cours",
        "done": "Terminés",
        "cancelled": "Annulés"
      },
      "searchPlaceholder": "Rechercher des travaux"
    },
    "deletePermanently": "Supprimer définitivement",
    "keepJob": "Garder le travail",
    "yesProceed": "Oui, continuer",
    "noTimeScheduled": "Aucune heure planifiée",
    "customerInformation": "Informations du client",
    "unknownContact": "Contact Inconnu",
    "assignees": "Assignés",
    "addAssignee": "Ajouter un assigné",
    "team": "Personnel",
    "selectAssignee": "Sélectionner un assigné",
    "role": "Rôle",
    "trade": "Métier",
    "removeAssignee": "Retirer",
    "kinds": {
      "undefined": "Non défini",
      "lead": "Principal",
      "assistant": "Assistant",
      "supervisor": "Superviseur",
      "technician": "Technicien",
      "dispatcher": "Répartiteur"
    },
    "trades": {
      "general": "Général",
      "electrical": "Électricité",
      "plumbing": "Plomberie",
      "hvac": "CVC",
      "gas": "Gaz",
      "mechanical": "Mécanique",
      "roofing": "Toiture",
      "carpentry": "Charpenterie",
      "painting": "Peinture",
      "flooring": "Revêtements de sol",
      "concrete": "Béton",
      "masonry": "Maçonnerie",
      "landscaping": "Aménagement paysager",
      "irrigation": "Irrigation",
      "fire_protection": "Protection incendie",
      "security": "Sécurité",
      "low_voltage": "Basse tension",
      "cleaning": "Nettoyage",
      "pest_control": "Extermination",
      "pool": "Piscine",
      "snow_removal": "Déneigement"
    },
    "technicians": "Techniciens",
    "techniciansOptional": "Techniciens (Optionnel)",
    "selectTechnicians": "Sélectionnez les techniciens",
    "onePersonSelected": "1 personne sélectionnée",
    "multiplePeopleSelected": "{count} personnes sélectionnées",
    "workDescription": "Description du travail",
    "buildProposal": "Créer une soumission",
    "viewProposal": "Voir la soumission",
    "awaitingDecision": "En attente",
    "confirmStatusTitle": "{action}",
    "confirmStatusDescription": "Confirmez que vous souhaitez {action} pour ce travail.",
    "sort": {
      "placeholder": "Trier par",
      "scheduledNewest": "Prévu (Plus récent)",
      "scheduledOldest": "Prévu (Plus ancien)",
      "createdNewest": "Créé (Plus récent)",
      "createdOldest": "Créé (Plus ancien)",
      "status": "Statut"
    },
    "cancelConfirmTitle": "Annuler ce travail ?",
    "underpriced": {
      "verb": "Prix trop bas pour ce travail",
      "unverb": "retirer",
      "mark": "Prix jugé trop bas",
      "byOn": "par {name}, le {date}",
      "on": "le {date}",
      "by": "par {name}",
      "toast": "Marqué « prix trop bas ». Le renouvellement proposera un nouveau prix.",
      "untoast": "Marque retirée."
    },
    "renewOnDone": {
      "title": "Même chose l'an prochain ?",
      "description": "Le travail est terminé. Le client reprend-il pour {label} ?",
      "year": "Pour quelle année ?",
      "yes": "Oui — renouveler pour {label}",
      "no": "Non — pas pour {label}",
      "absent": "Client absent, on rappellera"
    },
    "loseConfirmTitle": "Marquer comme perdu ?",
    "editTitle": "Modifier le travail",
    "updateSuccess": "Travail mis à jour.",
    "editTitleAction": "Modifier le titre",
    "addDescriptionAction": "Ajouter une note",
    "typeLocked": "Type verrouillé — le programme des visites et les travaux réalisés en découlent.",
    "searchPlaceholder": "Rechercher des travaux",
    "filter": {
      "all": "Tous",
      "active": "Actifs",
      "done": "Terminés",
      "cancelled": "Annulés",
      "leads": "Leads"
    },
    "assignSquad": "Assigner une équipe",
    "intake": {
      "next": "La suite",
      "createAndOpen": "Créer et ouvrir",
      "cards": {
        "lead": { "label": "Lead", "caption": "Rien de décidé" },
        "evaluation": { "label": "Évaluation", "caption": "Il faut aller voir" },
        "quote": { "label": "Soumission", "caption": "À rédiger, sans visite" },
        "won": { "label": "Vendu", "caption": "Le client a dit oui" }
      }
    },
    "quickCapture": {
      "addNote": "Note",
      "sectionWhen": "Quand ?",
      "typePlaceholder": "Chercher un type",
      "untitled": "Nouveau job"
    },
    "program": {
      "title": "Programme prévu",
      "onSignature": "sur signature",
      "hint": "Aperçu selon le type de travaux — ces visites seront créées à la signature de la soumission.",
      "interval": "+{min}–{max} j",
      "intervalExact": "+{days} j"
    },
    "preciseAssignees": "Assigner des personnes précises",
    "preciseAssigneesHint": "Au lieu de l'équipe — cas rare",
    "whoGoes": "Qui y va ?",
    "leadGuard": {
      "title": "Une évaluation est en cours à cette adresse",
      "continue": "Continuer sur ce job",
      "branch": "Nouveau job lié",
      "linked": "Lié à l’évaluation de ce job"
    },
    "createdBy": "créé par {name}",
    "steps": {
      "evaluation": "Évaluation",
      "noEvaluation": "Aucune évaluation",
      "noEvaluationShort": "Aucune",
      "evaluationDone": "Faite",
      "signed": "Signée",
      "sent": "Envoyée",
      "paidChip": "Payée",
      "invoicedChip": "Facturée",
      "balanceDue": "Solde dû {amount}",
      "proposal": "Soumission",
      "work": "Travaux",
      "invoice": "Facture",
      "addPhoto": "+ photo",
      "allPhotos": "toutes les {n}",
      "dropPhotos": "Glisser des photos ici",
      "wonVerbal": "Marquer vendu",
      "visitsDone": "{n} visite | {n} visites",
      "visitsProgress": "{done} sur {total} faites",
      "lastOn": "dernière le {date}",
      "atSignature": "À la signature",
      "program": "Programme",
      "asNeeded": "Au besoin",
      "columns": {
        "visit": "Visite",
        "when": "Quand",
        "crew": "Équipe",
        "duration": "Durée"
      },
      "photosTitle": "Photos",
      "addInvoice": "+ facture",
      "addVisit": "+ visite",
      "addVisitFull": "+ Ajouter une visite",
      "anotherOption": "+ Une autre option",
      "addWork": "+ Ajouter un travail",
      "optionLetter": "Option {letter}",
      "groupedSheet": "Soumission groupée",
      "signedOn": "signée le {date}",
      "openSheetPage": "Voir sur sa page",
      "unpricedLines": "{n} ligne sans prix | {n} lignes sans prix",
      "confirmSaleDescription": "La soumission {number} sera acceptée au nom du client.",
      "deleteDraftDescription": "Supprimer « {name} » ? Personne ne l’a vue."
    },
    "noDescription": "Aucune description.",
    "keys": {
      "navigate": "Y aller",
      "photos": "Photos"
    },
    "notes": {
      "title": "Notes",
      "add": "+ note",
      "write": "Écrire une note",
      "placeholder": "Note… {'@'} pour mentionner",
      "onJob": "Le job",
      "photo": "+ photo",
      "publish": "Publier",
      "all": "toutes les {n}",
      "seeOthers": "Voir l’autre note | Voir les {n} autres notes",
      "noMembers": "Aucun membre",
      "unknownMember": "membre",
      "systemAuthor": "Système",
      "visitAction": "Note",
      "deleteTitle": "Supprimer la note",
      "deleteDescription": "La note sera retirée du job. Ses photos restent dans la galerie."
    },
    "atAddress": {
      "heading": "Autres jobs à cette adresse",
      "children": "Créés depuis ce job",
      "newHere": "Nouveau job ici",
      "newHereField": "Autre job à cette adresse",
      "sameOrigin": "même origine",
      "more": "+ {n} autre | + {n} autres",
      "fewer": "Réduire"
    },
    "originJob": {
      "line": "Issu de {ref} · {type}",
      "lineUntyped": "Issu de {ref}"
    },
    "season": {
      "label": "Saison",
      "change": "changer",
      "idle": "en attente d'ouverture",
      "closed": "saison fermée",
      "updated": "Saison mise à jour",
      "none": "Sans saison",
      "evaluationHeld": "Évaluation en attente de l'ouverture de la saison"
    },
    "paymentFirst": {
      "label": "Paiement avant travaux",
      "held": "En attente du paiement",
      "lockedHint": "Ne change plus : les travaux sont payés, faits ou fermés",
      "enabled": "Paiement avant travaux activé",
      "disabled": "Paiement avant travaux retiré",
      "applyToCustomer": "Aussi pour les prochains jobs de {name}",
      "appliedToCustomer": "{name} paiera avant les travaux à l'avenir",
      "customerLabel": "Paiement avant travaux pour ses prochains jobs",
      "customerSaved": "Préférence de paiement enregistrée"
    },
    "renew": {
      "for": "Renouveler pour {label}",
      "otherSeasons": "Autres saisons",
      "toast": "Renouvelé pour {label}",
      "toastPlain": "Renouvelé",
      "dialogTitle": "Renouveler {label}",
      "notBefore": "Pas avant",
      "declined": "Ne sera pas renouvelé",
      "declinedYear": "Pas renouvelé en {year}",
      "reconsider": "annuler",
      "reconsidered": "Renouvellement de nouveau possible"
    },
    "noun": {
      "lead": "Lead",
      "dossier": "Dossier",
      "job": "Travaux"
    },
    "stage": {
      "evaluation_agreed": "Entendu — à placer",
      "lead": "Lead",
      "evaluation_booked": "Évaluation planifiée",
      "open": "Ouvert",
      "to_quote": "À soumissionner",
      "awaiting": "En attente de signature",
      "to_plan_work": "À planifier",
      "signed_to_plan": "Signé — à planifier",
      "work_in_bank": "Travaux en banque",
      "work_planned": "Travaux planifiés",
      "completed": "Terminé",
      "invoiced": "Facturation en cours",
      "paid": "Payé",
      "lost": "Perdu",
      "cancelled": "Annulé"
    },
    "coverage": {
      "title": "Cette soumission couvre"
    },
    "generate": {
      "title": "Cette soumission couvrira",
      "subtitle": "Une section par travail, un seul document, une seule signature.",
      "destination": "Destination",
      "newProposal": "Nouvelle soumission",
      "mode": {
        "work": "Depuis les travaux",
        "priced": "Montant convenu"
      },
      "addToThis": "Ajouter à cette soumission",
      "onDocument": "sur {number}",
      "alreadyOnDraft": "déjà sur le document",
      "noOffer": "aucune offre",
      "addWork": "+ Ajouter un travail",
      "newJob": "nouveau job",
      "removeAdded": "Retirer",
      "inForfait": "dans le forfait « {offer} »",
      "forfaitBlocked": {
        "onPaper": "{label} est déjà sur ce document",
        "sold": "{label} est déjà vendu à cette adresse"
      },
      "visitCount": "aucune visite | 1 visite | {count} visites",
      "footerCount": "{location} · {count} travaux ouverts",
      "submit": "Générer",
      "addSections": "Aucune section à ajouter | Ajouter 1 section | Ajouter {count} sections",
      "toast": "{number} — une section par travail coché"
    },
    "proposals": {
      "proposed": "Proposée",
      "priceMissing": "prix manquant",
      "emptyDraft": "brouillon vide · reprendre",
      "generate": "Générer",
      "send": "Envoyer",
      "sendTitle": "Envoyer au client",
      "delete": "Supprimer ce brouillon",
      "deleteConfirm": "Supprimer « {name} » ? Personne ne l’a vue.",
      "sendCount": "Envoyer ({count})",
      "emailHint": "Par courriel à {email}",
      "noEmailHint": "Aucun courriel au dossier — le lien sera à copier",
      "notRetained": "Non retenues ({count})",
      "signedOn": "Signée le {date}",
      "toast": {
        "sent": "{count} soumission envoyée | {count} soumissions envoyées",
        "noEmail": "Envoyée — aucun courriel au dossier, copiez le lien pour le client"
      }
    }
  },
  "squads": {
    "title": "Équipes",
    "subtitle": "Gérez vos équipes permanentes et leur camion.",
    "createNew": "Nouvelle équipe",
    "noSquads": "Aucune équipe définie pour le moment.",
    "addMember": "Ajouter un membre",
    "addPerson": "Ajouter une personne",
    "membersCount": "{count} membre | {count} membre | {count} membres",
    "lead": "Chef d'équipe",
    "deleteConfirmTitle": "Supprimer l'équipe ?",
    "deleteConfirmDescription": "Êtes-vous sûr de vouloir supprimer {name} ?",
    "fields": {
      "name": "Nom de l'équipe",
      "namePlaceholder": "ex: Équipe A Plomberie",
      "vehicle": "Camion",
      "vehiclePlaceholder": "Sélectionner un camion",
      "startDepot": "Part de",
      "startDepotPlaceholder": "Le siège (par défaut)",
      "endDepot": "Termine à",
      "endDepotPlaceholder": "Route ouverte (sans retour)",
      "workLane": "Travaux",
      "quoteLane": "Soumissions",
      "workTypes": "Types traités",
      "quoteTypes": "Types soumissionnés",
      "noTypes": "Aucun type",
      "addType": "Ajouter un type",
      "unitMoney": "$",
      "unitStops": "arrêts",
      "evaluationsPerDay": "évaluations / jour"
    },
    "sections": {
      "work": "Ce que l'équipe fait"
    },
    "hours": {
      "from": "Début",
      "to": "Fin",
      "break": "Pause",
      "breakUnit": "min",
      "breakTooLong": "La pause doit être plus courte que la journée."
    },
    "searchPlaceholder": "Rechercher une équipe"
  },
  "templates": {
    "title": "Types de job",
    "addNew": "Nouveau type de job",
    "searchPlaceholder": "Rechercher un type de job",
    "noTemplates": "Aucun type de job pour le moment.",
    "createNamed": "Créer le type « {name} »",
    "programTodo": "Programme à définir",
    "columns": {
      "todo": "À régler"
    },
    "createSuccess": "Type de job créé.",
    "updateSuccess": "Type de job mis à jour.",
    "deleteSuccess": "Type de job supprimé.",
    "stepAdded": "Visite ajoutée.",
    "stepUpdated": "Visite mise à jour.",
    "stepRemoved": "Visite retirée.",
    "deleteConfirmTitle": "Supprimer le type de job ?",
    "deleteConfirmDescription": "Supprimer « {name} » ? Les travaux existants ne sont pas affectés.",
    "steps": "Visites",
    "visits": {
      "title": "Visites",
      "asNeeded": "Au besoin",
      "addAsNeeded": "Ajouter une visite au besoin",
      "gapTo": "à",
      "gapLater": "jours plus tard",
      "noWindow": "Sans fenêtre",
      "none": "Aucune visite",
      "program": "Programme",
      "columns": {
        "visit": "Visite",
        "window": "Fenêtre",
        "duration": "Durée"
      },
      "dueWithin": "d'ici",
      "days": "jours"
    },
    "proposalTemplate": {
      "blankQuantityHint": "Vide = mesuré sur place",
      "blankQuantityPlaceholder": "À mesurer",
      "catalogPriceNow": "Prix catalogue aujourd'hui : {amount}",
      "notFound": "Modèle introuvable"
    },
    "appearance": {
      "title": "Apparence",
      "color": "Couleur",
      "auto": "Auto",
      "autoLabel": "Automatique",
      "customLabel": "Personnalisée"
    },
    "evaluation": {
      "title": "Évaluation",
      "duration": "Durée sur place",
      "durationPlaceholder": "Optionnel",
      "fee": "Frais",
      "feePlaceholder": "Gratuite",
      "quoteMode": "Soumission",
      "afterVisit": "Après une visite",
      "fromOffice": "Depuis le bureau"
    },
    "extraVisits": {
      "added": "Visite ajoutée.",
      "updated": "Visite mise à jour.",
      "removed": "Visite retirée.",
      "fields": {
        "dueWithinDays": "À faire d'ici (jours)"
      }
    },
    "addStep": "Ajouter une visite",
    "fields": {
      "name": "Nom",
      "namePlaceholder": "ex. Traitement antiparasitaire — 3 applications",
      "description": "Description",
      "descriptionPlaceholder": "Ce que couvre ce programme",
      "stepName": "Nom de la visite",
      "intervalMin": "Au plus tôt (jours)",
      "intervalMax": "Au plus tard (jours)",
      "duration": "Durée (min)"
    },
    "builder": {
      "startDate": "Date de début",
      "recent": "Types de job récents",
      "manage": "Gérer les types de job",
      "empty": "Aucun type de job — créez-en un d'abord."
    },
    "crews": {
      "title": "Équipes",
      "laneWork": "Travaux",
      "laneQuotes": "Soumissions",
      "add": "Ajouter une équipe",
      "none": "Aucune équipe",
      "ranked": "Priorité",
      "dropHere": "Glisser une équipe ici",
      "unranked": "Sans priorité",
      "rank": "Priorité {n}"
    },
    "proposalTemplates": {
      "title": "Modèles de soumission",
      "add": "Nouveau modèle",
      "namePlaceholder": "Nom (ex. Taille standard)",
      "rename": "Renommer",
      "delete": "Supprimer ce modèle",
      "deleteConfirm": "Supprimer « {name} » et toutes ses lignes ? Les soumissions déjà rédigées à partir de ce modèle restent intactes.",
      "empty": "Aucun modèle — un job de ce type part d'une soumission vide."
    }
  },
  "planning": {
    "title": "Planification",
    "standingDay": {
      "title": "Départ et heures de la journée",
      "subtitle": "Remplacer le dépôt et les heures habituels de l'équipe, pour cette journée seulement.",
      "hint": "S'applique à cette tournée uniquement. Relancez « Suggérer l'ordre » ensuite pour recalculer les heures.",
      "edit": "Départ et heures de la journée",
      "startDepot": "Part de",
      "endDepot": "Termine à",
      "hqDefault": "Le siège (par défaut)",
      "openRoute": "Route ouverte (sans retour)",
      "window": "Plage de travail",
      "start": "Début",
      "end": "Fin",
      "break": "Pause",
      "breakUnit": "min",
      "endAfterStart": "La fin doit être après le début.",
      "breakTooLong": "La pause doit être plus courte que la journée.",
      "saved": "Départ et heures de la journée mis à jour."
    },
    "filterByType": "Filtrer par type",
    "lens": {
      "types": "Types",
      "allWork": "Tous les travaux",
      "allQuotes": "Toutes les évaluations",
      "workPrefix": "Travaux",
      "quotesPrefix": "Évaluations"
    },
    "stopsCount": "{n} arrêt | {n} arrêts",
    "cellRung": {
      "proposed": "Proposée",
      "draft": "Brouillon",
      "unclosed": "{count} à clôturer"
    },
    "revise": {
      "action": "Modifier la journée",
      "hint": "La journée repasse en brouillon. Rien ne change pour le client tant que vous n'avez pas confirmé de nouveau.",
      "toast": "La journée est repassée en brouillon — confirmez-la de nouveau quand elle vous convient.",
      "addTitle": "Modifier la journée ?",
      "addDescription": "Cette journée est promise. Y ajouter un arrêt la rouvre en brouillon : les arrêts promis sont repris tels quels, et rien ne change pour le client tant que vous n'avez pas confirmé de nouveau.",
      "addConfirm": "Modifier la journée",
      "abandon": "Abandonner les modifications",
      "abandonTitle": "Abandonner les modifications ?",
      "abandonDescription": "Vos ajouts et l'ordre que vous avez donné sont perdus, et la journée confirmée reprend sa place. Les arrêts que vous avez retirés sont déjà retournés à la banque : les abandonner ne les ramène pas.",
      "abandonConfirm": "Abandonner",
      "abandonToast": "Modifications abandonnées.",
      "addedStop": "Ajouté à cette journée"
    },
    "collapseRow": "Replier cette rangée",
    "crewRow": {
      "perDay": "{value} / jour"
    },
    "expandRow": "Déplier cette rangée",
    "collapseAll": "Tout replier",
    "expandAll": "Tout déplier",
    "viewMap": "Voir la journée sur une carte",
    "today": "Aujourd'hui",
    "weekOf": "Semaine du {date}",
    "territoryMap": "Carte",
    "availability": {
      "titleScheduleWork": "Planifier des travaux",
      "book": "Réserver",
      "jobValue": "Valeur soumise : {amount}",
      "jobValueTypical": "Valeur typique du type (~)",
      "willDatePending": "la visite en attente sera datée",
      "willRedateCommitted": "déjà promise pour le {date} — ceci la redate",
      "willCreateVisit": "une visite de travaux sera créée",
      "bookedFirmToast": "Travaux réservés — semaine du {date}",
      "bookedFlexibleToast": "Travaux réservés — fenêtre du {from} au {to}, en attente dans la banque",
      "bookedBankToast": "Travaux envoyés à la banque — le Composer les placera",
      "viewWeek": "Voir la semaine"
    },
    "reserve": {
      "subtitle": "Placez les travaux en banque — le Composer les compose en journée — ou fixez un rendez-vous ferme."
    },
    "planEvaluation": {
      "title": "Planifier une évaluation",
      "openLeads": "Leads ouverts",
      "newLead": "Nouveau lead",
      "untypedLead": "Sans type",
      "leadBooked": "évaluation prévue le {date}",
      "leadAge": "ouvert aujourd'hui | ouvert il y a {n} jour | ouvert il y a {n} jours",
      "willBook": "Réservera l'évaluation en attente de ce client",
      "willCreate": "Créera l'évaluation pour ce client",
      "submit": "Planifier",
      "submitBank": "Envoyer en banque",
      "submitFirm": "Fixer le rendez-vous",
      "alreadyInBank": "Déjà en banque"
    },
    "deadlines": {
      "due": "{count} fenêtre ferme · {amount} | {count} fenêtres ferment · {amount}"
    },
    "priority": {
      "late": "{count} en retard · {amount}",
      "next": "Prochaines :",
      "dueOn": "dû {date}",
      "toSchedule": "{n} signé à planifier | {n} signés à planifier",
      "toQuote": "{n} à soumissionner | {n} à soumissionner",
      "empty": "Rien en retard, aucune fenêtre ne ferme bientôt."
    },
    "mode": {
      "operations": "Opérations",
      "sales": "Ventes"
    },
    "pipelineView": {
      "searchPlaceholder": "Rechercher un client",
      "typesPlaceholder": "Type de travaux"
    },
    "confirm": "Confirmer",
    "overCapacity": "Dépasse de {minutes} min",
    "discardDraft": "Rejeter le brouillon",
    "discardTitle": "Rejeter ce plan brouillon ?",
    "discardDescription": "La suggestion est supprimée; rien n'a été écrit sur les visites. Vous pouvez recalculer en tout temps.",
    "status": {
      "draft": "Brouillon",
      "confirmed": "Confirmé"
    },
    "receipt": {
      "evaluated": "Évalué",
      "noOutcome": "à clôturer",
      "deferred": "Reportée",
      "openJob": "Ouvrir le job",
      "emptyDay": "Rien à montrer pour cette journée.",
      "done": "Fait {value}",
      "target": "Cible {value}"
    },
    "closures": {
      "tab": "Clôtures",
      "searchPlaceholder": "Rechercher une équipe",
      "hint": "Ces journées gardent des arrêts à clôturer — clôturez-les pour que la banque et le retard disent vrai.",
      "looseCount": "{n} à clôturer",
      "empty": "Toutes les journées sont clôturées.",
      "alreadyClosed": "Rien à clôturer pour cette journée."
    },
    "emptyDay": {
      "button": "Vider la journée",
      "confirm": "Vider la journée — {count} jobs à la banque",
      "toast": "{count} jobs remis à la banque"
    },
    "closeDay": {
      "title": "Clôturer la journée",
      "hint": "Un verdict pour chaque arrêt non résolu — rien ne se ferme en bloc.",
      "outcome": {
        "completed": "Complété",
        "deferred": "Reporté",
        "cancelled": "Annulé"
      },
      "openJob": "Ouvrir le job",
      "unanswered": "{n} arrêt sans réponse | {n} arrêts sans réponse",
      "submit": "Clôturer la journée",
      "submitWithProposed": "Clôturer ({n} proposée) | Clôturer ({n} proposées)",
      "proposedTitle": {
        "completed": "Proposé : commencé, et l'équipe a continué après cet arrêt",
        "deferred": "Proposé : jamais commencé, et l'équipe a continué après cet arrêt"
      },
      "toastClosed": "Journée clôturée",
      "toastDeferred": "{n} retournée à la banque | {n} retournées à la banque"
    },
    "willAssign": "Sera assigné : {name}",
    "minutesDrive": "{n} min de route",
    "minutesDriveShort": "{n} min",
    "stopNoTime": "Heure à définir",
    "noTargetBar": "Aucune cible",
    "unassignedTitle": "Impossible à placer cette semaine",
    "excludedTitle": "Exclus du calcul",
    "unplaced": {
      "excludedTag": "Exclu",
      "dismiss": "Masquer cette liste"
    },
    "reason": {
      "not_geocoded": "L'adresse n'a pas de coordonnées (géocodage échoué ou en attente)",
      "no_slot_in_window": "Aucune place dans sa fenêtre de retraitement",
      "flexible": "Aucune fenêtre — peut être placé en tout temps",
      "unassigned": "Impossible à placer"
    },
    "confirmSuccess": "Plan confirmé — horaires des visites écrits.",
    "discardSuccess": "Plan brouillon rejeté.",
    "replanSuccess": "Reste de la journée replanifié — révisez et confirmez.",
    "atRisk": "À risque",
    "riskReason": {
      "visit_cancelled": "Un arrêt a été annulé",
      "visit_skipped": "Un arrêt a été sauté",
      "window_drift": "Un arrêt est sorti de sa fenêtre de retraitement",
      "appointment_added": "Un rendez-vous a été ajouté"
    },
    "runningLong": "Dépasse le temps prévu",
    "frozen": "Figé",
    "confirmDialog": {
      "title": "Confirmer ce plan",
      "description": "La confirmation écrit ces horaires de rendez-vous sur les visites. Appelez d'abord les clients concernés.",
      "bucketDescription": "La confirmation engage ces jobs sur cette journée — une promesse de jour, sans heure de rendez-vous.",
      "dayLevelTime": "{date} (journée)",
      "callNote": "Clients à appeler — leur horaire a changé",
      "droppedNote": "Plus dans la tournée d'aujourd'hui — replanifier ou annuler",
      "noCallNeeded": "Aucun appel nécessaire — aucune promesse d'heure faite",
      "noChanges": "Aucun horaire de rendez-vous client ne change. Confirmation sans risque.",
      "customer": "Client",
      "phone": "Téléphone",
      "newTime": "Nouvel horaire",
      "newAppointment": "nouveau"
    },
    "dayFace": {
      "done": "faits",
      "emptyDay": "Journée vide",
      "previousDay": "Jour précédent",
      "nextDay": "Jour suivant",
      "results": "Résultats",
      "searchPlaceholder": "Client, adresse, n° de job",
      "notEquipped": "Pas équipée",
      "addToDay": "Ajouter à la journée",
      "adding": "ajout en cours | {count} ajouts en cours",
      "adoptAndAdd": "Adopter le {count} coché + {name} | Adopter les {count} cochés + {name}",
      "addAlone": "{name} seulement",
      "addAloneHint": "La proposition retourne à la banque.",
      "headroom": "reste {amount}",
      "overTarget": "au-delà de la cible",
      "removeFromDay": "Retirer de la journée",
      "notLocated": "Adresse non localisée — impossible de situer cet arrêt sur la carte",
      "nextProposition": "Ouvrir",
      "conveyorLabel": "Journée proposée suivante → {day} · {crew}"
    },
    "kind": {
      "bucket": "Journée flexible"
    },
    "bucket": {
      "createSuccess": "Journée préparée — glissez-y des jobs depuis la banque.",
      "adopted": "Proposition adoptée · {count} arrêt | Proposition adoptée · {count} arrêts",
      "suggestOrder": "Ordonner",
      "suggestOrderHint": "Calcule un ordre de route pour cette journée — les heures affichées sont des indices, jamais des promesses.",
      "suggestSuccess": "Ordre suggéré — les heures sont des indices de route seulement.",
      "empty": "Glissez des jobs ici depuis la banque",
      "remove": "Retirer de cette journée",
      "discard": "Supprimer le brouillon"
    },
    "unplacedChip": "À placer sur la tournée",
    "missed": {
      "title": "Sans équipe",
      "count": "{n} à régler | {n} à régler",
      "crewPrompt": "Quelle équipe l'a fait ?",
      "crewMissing": "{n} équipe à indiquer | {n} équipes à indiquer",
      "callBack": "Rappeler {name}",
      "submit": "Régler",
      "toastResolved": "Réglé"
    },
    "bank": {
      "empty": "Aucune visite non planifiée."
    },
    "fill": {
      "button": "Remplir",
      "scope": "Remplissage : {sectors}",
      "hint": "Remplir depuis la banque (selon son filtre de secteur actuel), les plus urgentes d'abord, jusqu'à l'objectif du jour",
      "needsTarget": "Fixez d'abord un objectif du jour sur cette case — c'est l'objectif qui guide le remplissage.",
      "nothingToFill": "Rien dans la banque n'entre dans le budget restant."
    },
    "dayTarget": {
      "label": "Objectif du jour",
      "labelWithUnit": "Objectif du jour ({unit})",
      "hint": "Un plafond souple pour la journée de cette équipe — sert à y choisir les jobs.",
      "defaultHint": "L'objectif par défaut de l'équipe — enregistrez pour fixer ce jour explicitement.",
      "set": "Définir",
      "clear": "Effacer",
      "placeholder": "Montant",
      "placeholderStops": "Arrêts",
      "unitLabel": "Unité",
      "unit": {
        "money": "$",
        "stops": "Arrêts"
      },
      "actualHint": "Travail réservé sur ce plan (au prorata des visites)"
    },
    "placement": {
      "bank": "Banque",
      "firm": "Date fixe",
      "window": "Le client souhaite une période",
      "date": "Date",
      "timeOptional": "Heure — optionnelle",
      "appointment": "Rendez-vous",
      "timePromisedLead": "Heure promise au client",
      "timePromisedRest": "— la tournée s'organise autour."
    },
    "view": {
      "week": "Semaine",
      "pipeline": "Pipeline",
      "month": "Mois"
    },
    "composer": {
      "ghost": {
        "more": "{count} de plus",
        "proposedLine": "{count} arrêt proposé | {count} arrêts proposés"
      },
      "adopt": "Adopter",
      "adoptCount": "Adopter {count} arrêt | Adopter {count} arrêts",
      "panel": {
        "composed": "journée proposée",
        "close": "Fermer",
        "checked": "{checked} de {total} cochés",
        "toggleAll": "Tout cocher, ou rien"
      },
      "composing": "composition…",
      "toc": {
        "title": "Journées proposées",
        "button": "Composeur",
        "pool": "Le bassin · 14 jours",
        "cols": {
          "waiting": "En attente",
          "placed": "Placés",
          "unplaced": "Sans journée"
        },
        "ripeCount": "{count} prête | {count} prêtes",
        "filling": "{count} en formation | {count} en formation",
        "composing": "composition…"
      },
      "demand": {
        "title": "Composé sur 14 jours"
      },
      "placedOn": "Proposée pour le {date} · {crew}",
      "noRuns": "Aucune journée proposée"
    },
    "candidates": {
      "updatedAgo": "mis à jour il y a {min} min",
      "recompose": "Recomposer",
      "computing": "Composition des journées…",
      "emptyHint": "Les journées apparaissent à mesure que le travail en attente s'accumule dans le secteur de chaque équipe.",
      "ofCap": "/ {cap}",
      "mapPreview": "Aperçu du trajet sur une carte",
      "reforming": "recalcul…",
      "recomputed": "Recalculée",
      "composeFailedHint": "composition échouée — nouvel essai",
      "committed": "Journée adoptée pour le {date}",
      "committedPartial": "Adoptée pour le {date} · {dropped} arrêt déjà pris | Adoptée pour le {date} · {dropped} arrêts déjà pris",
      "stop": {
        "visitOfCount": "visite {ordinal} de {count}",
        "eta": "≈ {time}",
        "openJob": "Ouvrir le job"
      },
      "card": {
        "evaluation": "Soumissions",
        "untyped": "Sans type"
      },
      "untyped": {
        "residue": "{count} job sans type | {count} jobs sans type",
        "assignType": "Choisir un type",
        "assigned": "Type assigné"
      },
      "run": {
        "ripe": "Prête",
        "filling": "En formation"
      },
      "warnings": {
        "no_capable_crew": "aucune équipe pour ce type",
        "untyped": "sans type — à placer à la main"
      }
    },
    "liveMap": {
      "noCustomer": "Sans client",
      "stacked": "{count} travaux à cette adresse",
      "unavailable": "La carte est indisponible — aucun jeton Mapbox n'est configuré.",
      "popover": {
        "openJob": "Ouvrir le job",
        "treatmentOfN": "Traitement {index} sur {total}",
        "perVisit": "par visite",
        "stopOn": "Passage le {date}",
        "eta": "ETA {time}",
        "draft": "plan brouillon",
        "promisedOn": "Promis pour le {date}",
        "completedOn": "Faite le {date}",
        "scheduledAt": "Prévu le {date}",
        "overdueSince": "En retard depuis le {date}",
        "dueBy": "À faire avant le {date}",
        "window": "Fenêtre {from} → {to}"
      }
    },
    "pastEmpty": {
      "label": "Aucun travail"
    },
    "offSchedule": {
      "label": "Hors horaire",
      "hint": "Cette équipe ne travaille pas normalement ce jour-là. La journée reste remplissable — elle prend l'horaire habituel de l'équipe, modifiable au jour le jour."
    },
    "season": {
      "ceilingSentence": "{name} : composeur jusqu'au {date}"
    },
    "propose": {
      "action": "Remplir",
      "success": "{count} arrêt ajouté · {amount} | {count} arrêts ajoutés · {amount}",
      "successStops": "{count} évaluation ajoutée | {count} évaluations ajoutées",
      "allTypes": "Tous les types",
      "nothingAdded": "Les rendez-vous du jour couvrent déjà la cible — rien d'ajouté de la banque.",
      "nothing": "Rien à ajouter : aucun travail en attente ne correspond à ce camion et ce jour."
    },
    "suggestDay": {
      "action": "Suggérer un jour",
      "title": "Où placer cette visite ?",
      "empty": "Aucun jour ne convient : pas de journée ouverte avec de la place avant la fin de la fenêtre.",
      "reasonSector": "{count} arrêt déjà dans ce secteur | {count} arrêts déjà dans ce secteur",
      "reasonRoom": "{amount} restant sur l'objectif",
      "reasonWindow": "Dans la fenêtre",
      "reasonLate": "Fenêtre déjà fermée",
      "place": "Placer ici"
    },
    "dayOff": {
      "declare": "Annuler la journée",
      "reason": "Raison",
      "reasons": {
        "weather": "Météo",
        "crew_unavailable": "Équipe indisponible",
        "vehicle_down": "Camion hors service",
        "other": "Autre"
      },
      "cancelled": "Journée annulée",
      "reopen": "Rouvrir la journée",
      "reopened": "Journée rouverte",
      "declareEllipsis": "Annuler la journée",
      "declareHint": "{crew} · {date} · {count} arrêt | {crew} · {date} · {count} arrêts",
      "reasonRequired": "Choisissez une raison.",
      "note": "Précision (optionnel)",
      "noteRequired": "Précision (requise pour « Autre »)",
      "notePlaceholder": "ex. le remplacement arrive jeudi",
      "noteRequiredForOther": "Dites en un mot ce qui se passe.",
      "noteTooLong": "{max} caractères maximum.",
      "submitDeclare": "Déclarer",
      "resolve": "Régler les arrêts",
      "reviewTitle": "{crew} — journée annulée",
      "reviewHint": "Chaque arrêt a besoin d'une réponse. Les clients à qui une heure a été promise sont en premier.",
      "stopsToResolve": "{count} arrêt à régler | {count} arrêts à régler",
      "deferAll": "Tout reporter",
      "nothingToResolve": "Rien à régler sur cette journée.",
      "called": "appelé",
      "promisedAt": "{time} promis",
      "datedOnly": "Journée",
      "dayOnly": "Sans heure",
      "submit": "Clôturer la journée"
    },
    "previousWeek": "Semaine précédente",
    "nextWeek": "Semaine suivante",
    "popover": {
      "crew": {
        "intent": "Prévu : {crew}",
        "placement": "Journée de {crew}"
      }
    },
    "noCrews": "Aucune équipe",
    "noCrewsHint": "Le tableau planifie les journées des équipes : créez-en une dans « Flotte ».",
    "previousMonth": "Mois précédent",
    "nextMonth": "Mois suivant",
    "month": {
      "off": "annulée",
      "unassigned": "Sans équipe",
      "unavailable": "Le mois n’a pas pu être chargé.",
      "marks": {
        "done": "Faites",
        "underway": "En cours",
        "planned": "Prévues",
        "unresolved": "Sans verdict",
        "skipped": "Ignorées",
        "deferred": "Retour en banque"
      },
      "evaluations": "éval.",
      "day": {
        "unavailable": "Impossible de charger cette journée.",
        "empty": "Rien ce jour-là.",
        "openWeek": "Ouvrir dans Semaine",
        "buildDay": "Bâtir cette journée",
        "doneAt": "Terminée à {time}"
      },
      "rowState": {
        "done": "Faite",
        "skipped": "Ignorée",
        "deferred": "Retournée en banque",
        "unresolved": "Sans verdict",
        "underway": "En cours",
        "planned": "Prévue"
      }
    },
    "crewsUnavailable": "Les équipes n’ont pas pu être chargées : le tableau n’a aucune rangée à dessiner.",
    "pickWeek": "Choisir une semaine"
  },
  "proposals": {
    "title": "Soumissions",
    "index": {
      "empty": "Aucune soumission pour l'instant.",
      "tabs": {
        "all": "Toutes"
      },
      "sort": {
        "placeholder": "Trier",
        "createdNewest": "Plus récentes",
        "createdOldest": "Plus anciennes",
        "status": "Statut"
      },
      "columns": {
        "status": "État",
        "customer": "Client",
        "dossier": "Dossier",
        "amount": "Montant",
        "due": "Échéance"
      },
      "due": {
        "expires": "expire le {date}",
        "on": "le {date}",
        "signed": "signée le {date}",
        "since": "depuis {count} j"
      }
    },
    "builder": "Constructeur de soumission",
    "clientReview": "Révision client",
    "acceptAndSign": "Accepter et signer",
    "acceptAndSignSubtitle": "J'autorise les travaux décrits dans « {title} ».",
    "beginWork": "Accepter et signer",
    "startQuote": "Soumissionner",
    "quoteDrawerTitle": "Soumission",
    "signedTitle": "Signé",
    "signedSubtitle": "{title} · {amount}",
    "acceptance": "Soumission et acceptation",
    "customerSignature": "Signature du client",
    "waitingSignature": "En attente de la signature du client...",
    "noneYet": "Aucune soumission",
    "notFound": "Soumission introuvable",
    "noProposal": "Aucune soumission n'a encore été créée pour ce travail.",
    "afterEvaluation": "La soumission se rédige après l'évaluation.",
    "noItems": "Aucun article ajouté pour l'instant.",
    "acceptedBanner": "Cette soumission a été acceptée par le client.",
    "number": "Soumission #{number}",
    "itemCount": "{count} article | {count} articles",
    "create": "Créer une soumission",
    "createSuccess": "Soumission créée avec succès.",
    "acceptSuccess": "Soumission acceptée ! Vous pouvez maintenant commencer le travail.",
    "subtotal": "Sous-total",
    "discount": "Rabais",
    "taxes": "Taxes",
    "total": "Total",
    "addTax": "Ajouter une taxe",
    "removeTax": "Retirer",
    "overrideRate": "Modifier",
    "fromCatalog": "Du catalogue",
    "customTax": "Taux personnalisé",
    "validUntil": "Valide jusqu'au {date}",
    "expired": "Expirée",
    "setExpiry": "Date d'expiration",
    "clearExpiry": "Retirer la date",
    "margin": "Marge",
    "marginTooltip": "Marge — % de profit sur le coût",
    "details": {
      "title": "Précisions",
      "addPlaceholder": "Ajouter une précision",
      "addChip": "+ Autre précision"
    },
    "row": {
      "addDetail": "+ précision",
      "suggested": "Précisions suggérées",
      "taxes": "Taxes",
      "discountLine": "Rabais sur la ligne",
      "addDescription": "+ description",
      "moveTo": "Déplacer vers",
      "toAddons": "Suppléments",
      "includeBack": "Inclure dans la soumission",
      "remove": "Retirer la ligne"
    },
    "columns": {
      "line": "Ligne",
      "quantity": "Quantité",
      "price": "Prix"
    },
    "addLineFoot": "Ajouter une ligne",
    "pendingLinePlaceholder": "Nom de la ligne, ou cherchez le catalogue",
    "lineItemKind": {
      "material": "Matériau",
      "labor": "Main-d'œuvre",
      "fee": "Frais"
    },
    "unit": "Unité",
    "unitPlaceholder": "ch., h, pi...",
    "discountPercent": "Rabais %",
    "addOn": "Supplément",
    "markAsAddOn": "Marquer comme supplément (exclu du total)",
    "taxable": "Taxable",
    "taxableShort": "Taxe",
    "addOns": "Suppléments",
    "includeItem": "Inclure",
    "excludeItem": "Exclure",
    "newSection": "Nouvelle section",
    "newSectionDefault": "Nouvelle section",
    "renameGroup": "Renommer la section",
    "explodeGroup": "Dégrouper (conserver les articles)",
    "deleteSectionAndItems": "Supprimer la section et les articles",
    "deleteSectionConfirm": "Supprimer « {name} » et tous ses articles ? Cette action est irréversible.",
    "replacedUnderYou": "Cette soumission a été remplacée",
    "states": {
      "draft": "Brouillon",
      "pending": "En attente",
      "accepted": "Acceptée",
      "rejected": "Refusée",
      "lost": "Perdue",
      "expired": "Expirée",
      "superseded": "Remplacée"
    },
    "timeline": {
      "sentBy": "Soumission envoyée par {channel}",
      "delivered": "Transmission notée",
      "title": "Historique",
      "created": "Soumission {number} créée",
      "presented": "Présentée au client",
      "accepted": "Acceptée",
      "acceptedSigned": "Acceptée avec signature",
      "acceptedManually": "Approuvée manuellement",
      "acceptedVerbally": "Acceptée — entente verbale",
      "rejected": "Refusée",
      "revised": "Rouverte pour révision",
      "expired": "Marquée comme expirée",
      "assemblyApplied": "Ensemble « {name} » ajouté",
      "groupRemoved": "Section « {name} » retirée",
      "groupExploded": "Section « {name} » dissoute",
      "discountUpdated": "Rabais modifié",
      "validitySet": "Expiration fixée au {date}",
      "validityChanged": "Expiration modifiée du {from} au {to}",
      "validityCleared": "Date d’expiration retirée",
      "taxAdded": "Taxe « {name} » ajoutée",
      "taxRemoved": "Taxe « {name} » supprimée",
      "taxRateOverridden": "Taux modifié pour « {name} »",
      "superseded": "Remplacée par {number} — le client en a choisi une autre",
      "supersededNoPaper": "Remplacée — vendu sans soumission",
      "coverageAdded": "Section {label} ajoutée · {number}",
      "coverageAddedMany": "Sections ajoutées : {list}"
    },
    "forfait": {
      "badge": "Forfait",
      "createsJob": "+ crée le job {types}",
      "partOf": "Fait partie de :",
      "typeChip": "Type : {name}",
      "backToOwnType": "Revenir au type du modèle",
      "addTypedSection": "+ Section d'un autre type",
      "pickType": "Type de la section",
      "seedFrom": "Partir du modèle",
      "seedNone": "Section vide",
      "add": "Ajouter la section"
    },
    "quote": {
      "howMuch": "Combien ?",
      "standardFor": "Soumission pour {type}",
      "standardNone": "Aucune soumission standard pour {type}",
      "standardNoType": "Aucun type de job",
      "agreedHint": "On s'entend sur un prix",
      "change": "Changer",
      "unpriced": "Prix manquant",
      "pricePlaceholder": "Prix",
      "discarded": "Brouillon abandonné",
      "lockedHint": "Déjà présentée au client — les quantités sont figées"
    },
    "presentToCustomer": "Rendre accessible au client",
    "presentOnTablet": "Présenter au client",
    "publicLink": {
      "menu": "Lien public",
      "copy": "Copier le lien",
      "copied": "Lien copié",
      "sendEmail": "Envoyer par courriel",
      "emailSent": "Courriel envoyé au client",
      "regenerate": "Régénérer le lien",
      "regenerated": "Nouveau lien créé — tous les liens partagés sont morts"
    },
    "viewPdf": "Voir le PDF",
    "revise": "Réviser",
    "recordDecision": "Enregistrer la décision",
    "markApproved": "Marquer approuvée",
    "markApprovedConfirm": "Confirmer que le client a approuvé cette soumission sur une copie imprimée ? Cela sera enregistré sous votre nom.",
    "markDeclined": "Marquer refusée",
    "markDeclinedConfirm": "Confirmer que le client a refusé cette soumission ? Cela sera enregistré sous votre nom.",
    "approvedManually": "Approuvée manuellement",
    "awaitingDecision": "En attente de la décision du client",
    "optionalTotal": "Suppléments optionnels",
    "inProposalCount": "{count} déjà dans cette soumission",
    "expiredOn": "Expirée le {date}",
    "removeFromSection": "Retirer de la section",
    "emptySection": "Section vide — déplacez des articles ici ou ajoutez des pièces.",
    "sectionActions": "Gérer cette section.",
    "moveGroupUp": "Monter",
    "moveGroupDown": "Descendre",
    "reviewTitle": "Votre soumission",
    "reviewSubtitle": "Vérifiez les travaux et le montant, puis signez ci-dessous.",
    "acceptedDocument": "Soumission acceptée"
  },
  "parts": {
    "suggest": {
      "loading": "Recherche dans le catalogue…",
      "custom": "Ligne libre « {name} »",
      "onHand": "{n} en stock"
    },
    "title": "Catalogue de prix",
    "addItem": "Ajouter un article",
    "addTitle": "Ajouter au catalogue de prix",
    "emptyTitle": "Catalogue de prix vide",
    "createSuccess": "Article ajouté au catalogue.",
    "updateSuccess": "Article mis à jour.",
    "deleteSuccess": "Article supprimé.",
    "deleteConfirmTitle": "Retirer du catalogue ?",
    "deleteConfirmDescription": "Retirer {name} du catalogue ? Les postes de ligne existants ne seront pas affectés.",
    "searchPlaceholder": "Rechercher le catalogue",
    "fields": {
      "name": "Nom de l'article",
      "namePlaceholder": "ex. Taux horaire standard",
      "description": "Description",
      "descriptionPlaceholder": "Détails optionnels",
      "unitPrice": "Prix unitaire ($)",
      "sku": "SKU / Code",
      "skuPlaceholder": "ex. EL-001",
      "unit": "Unité",
      "unitPlaceholder": "unité, hr, m²...",
      "costPrice": "Prix de revient ($)",
      "taxable": "Taxable",
      "onHand": "En stock",
      "trackInventory": "Suivre l'inventaire",
      "lowStockThreshold": "Seuil de stock bas"
    },
    "pickerPlaceholder": "Choisir un article",
    "tabs": {
      "all": "Tous",
      "lowStock": "Stock bas"
    },
    "sort": {
      "nameAsc": "Nom (A–Z)",
      "nameDesc": "Nom (Z–A)",
      "priceHighest": "Prix (le plus élevé)",
      "priceLowest": "Prix (le plus bas)",
      "newest": "Plus récents d'abord",
      "oldest": "Plus anciens d'abord"
    },
    "stock": {
      "title": "Stock",
      "notTracked": "L'inventaire n'est pas suivi pour cet article. Activez le suivi dans les paramètres de l'article pour gérer le stock.",
      "lowStock": "Stock bas",
      "adjustAction": "Ajuster le stock",
      "adjustTitle": "Ajuster le stock",
      "adjustDescription": "Ajoutez ou retirez une quantité, ou définissez le total compté.",
      "adjustSuccess": "Stock mis à jour.",
      "adjustHint": "Utilisez un montant négatif pour retirer du stock.",
      "modes": {
        "adjust": "Ajuster ±",
        "set": "Définir le compte"
      },
      "fields": {
        "amount": "Quantité",
        "newCount": "Nouveau compte",
        "note": "Note",
        "notePlaceholder": "ex. Livraison reçue, unité endommagée..."
      }
    },
    "movements": {
      "title": "Historique des mouvements",
      "empty": "Aucun mouvement de stock pour le moment.",
      "loadMore": "Charger plus",
      "system": "Système",
      "reasons": {
        "adjustment": "Ajustement",
        "count": "Comptage"
      },
      "fields": {
        "date": "Date",
        "reason": "Raison",
        "delta": "Variation",
        "performedBy": "Par",
        "note": "Note"
      }
    }
  },
  "settings": {
    "title": "Paramètres",
    "subtitle": "Gérez votre profil et la configuration de votre organisation.",
    "updateSuccess": "Profil mis à jour avec succès.",
    "backToApp": "Retour à l'application",
    "groups": {
      "company": "L'entreprise",
      "field": "Le terrain",
      "accounting": "La comptabilité"
    },
    "identity": {
      "dataSources": {
        "osm": "© les contributeurs d'OpenStreetMap,",
        "osmLicence": "ODbL",
        "quebec": "Données : © Gouvernement du Québec — Référentiel québécois des adresses et Découpage administratif, données adaptées,",
        "quebecLicence": "CC BY 4.0"
      },
      "languageHint": "Vos documents et courriels aux clients.",
      "logo": {
        "empty": "Aucun logo",
        "instructions": "Cliquez ou glissez une image.",
        "remove": "Retirer"
      }
    },
    "paper": {
      "contactEmail": "Courriel de contact client",
      "contactEmailHint": "Imprimé sur vos documents, et adresse de réponse de vos envois.",
      "contactEmailMissing": "Sans courriel, vos clients ne peuvent pas répondre à vos envois."
    },
    "territory": {
      "anchor": {
        "title": "Point de départ des trajets"
      }
    },
    "tabs": {
      "profile": "Profil",
      "general": "Identité",
      "paper": "Papier d'affaires",
      "members": "Membres",
      "businessHours": "Heures d'ouverture",
      "taxes": "Taxes",
      "payments": "Paiements",
      "sectors": "Territoire",
      "imports": "Importations",
      "notifications": "Notifications",
      "weather": "Météo",
      "closures": "Fermetures"
    },
    "payments": {
      "title": "Paiements",
      "hint": "Comment vos clients paient leurs factures. L'argent va directement à votre entreprise, jamais par Vitesse.",
      "interac": {
        "title": "Virement Interac",
        "description": "Imprimé sur chaque facture à payer : l'adresse, le montant et le numéro de facture à inscrire dans le message. Gratuit pour vous.",
        "email": "Adresse de dépôt automatique",
        "placeholder": "paiements{'@'}entreprise.ca",
        "invalid": "Entrez une adresse courriel complète (ex. paiements{'@'}entreprise.ca)."
      },
      "cardTitle": "Compte Stripe",
      "contactEmail": "Courriel du compte Stripe",
      "contactEmailHint": "L'adresse par laquelle Stripe joint le titulaire du compte. Vos clients ne la voient jamais.",
      "states": {
        "disconnected": "Non connecté",
        "pending": "Configuration à terminer",
        "active": "Actif"
      },
      "descriptions": {
        "disconnected": "Connectez un compte Stripe pour permettre à vos clients de payer leurs factures par carte depuis leur page de facture.",
        "pending": "Le compte Stripe existe mais la configuration n'est pas terminée — les paiements restent désactivés tant que Stripe n'autorise pas les transactions.",
        "active": "Les paiements par carte sont activés. Remboursements, litiges et versements se gèrent dans votre propre tableau de bord Stripe."
      },
      "connect": "Connecter Stripe",
      "resume": "Terminer la configuration",
      "verify": "Vérifier",
      "openDashboard": "Ouvrir le tableau de bord Stripe",
      "restart": "Recommencer",
      "restartConfirmTitle": "Recommencer la connexion à Stripe ?",
      "restartConfirmBody": "La configuration inachevée est abandonnée. « Connecter Stripe » repartira de zéro."
    },
    "profile": {
      "title": "Informations du profil",
      "subtitle": "Mettez à jour vos informations personnelles.",
      "firstName": "Prénom",
      "lastName": "Nom de famille",
      "locale": "Langue",
      "save": "Enregistrer les modifications"
    },
    "contactSupport": "Contacter le support",
    "organization": {
      "proposalValidity": "Validité des soumissions (jours)",
      "proposalValidityHint": "Une soumission expire ce nombre de jours après la création de son brouillon. Laisser vide pour aucune expiration.",
      "hqPlaceholder": "ex. 5195 Boulevard Guillaume-Couture, Lévis, QC",
      "hqHint": "Sert à estimer les temps de route pour le badge de zone de service. Les coordonnées se résolvent automatiquement.",
      "hqPending": "Résolution de l'adresse…",
      "viewHqMap": "Voir le siège sur une carte",
      "hqResolved": "Résolue : {lat}, {lng}",
      "serviceAreaHint": "Au-delà de ce temps de route depuis le siège, l'emplacement porte le badge Hors zone. Jamais bloquant.",
      "letterhead": "En-tête public",
      "letterheadHint": "Ce que la page publique de soumission montre à votre client. Les champs vides ne s'affichent pas.",
      "taglinePlaceholder": "ex. Entrepreneur électricien",
      "rbqPlaceholder": "ex. 5678-1234-01",
      "locale": "Langue par défaut",
      "businessHours": {
        "title": "Heures d'ouverture",
        "hint": "Jours et heures de travail par défaut. La planification des tournées ne programme les visites que les jours ouverts, à l'intérieur de ces heures.",
        "open": "Ouvert",
        "closed": "Fermé",
        "start": "Heure d'ouverture",
        "end": "Heure de fermeture",
        "endAfterStart": "L'heure de fermeture doit être après l'heure d'ouverture.",
        "days": {
          "mon": "Lundi",
          "tue": "Mardi",
          "wed": "Mercredi",
          "thu": "Jeudi",
          "fri": "Vendredi",
          "sat": "Samedi",
          "sun": "Dimanche"
        }
      }
    },
    "taxes": {
      "title": "Taux de taxes",
      "subtitle": "Définissez les taxes appliquées aux soumissions.",
      "nav": "Taxes"
    }
  },
  "taxes": {
    "title": "Taux de taxes",
    "subtitle": "Configurez les taxes à appliquer sur les soumissions.",
    "addNew": "Nouvelle taxe",
    "createSuccess": "Taxe créée.",
    "updateSuccess": "Taxe mise à jour.",
    "deactivateSuccess": "Taxe désactivée.",
    "restoreSuccess": "Taxe restaurée.",
    "deactivate": "Désactiver",
    "restore": "Restaurer la taxe",
    "addedToProposal": "Taxe ajoutée.",
    "removedFromProposal": "Taxe retirée.",
    "deleteConfirmTitle": "Désactiver la taxe ?",
    "deleteConfirmDescription": "Désactiver « {name} » la masquera dans les nouvelles soumissions. Les taxes existantes ne sont pas affectées.",
    "noTaxes": "Aucune taxe configurée.",
    "fields": {
      "name": "Nom de la taxe",
      "namePlaceholder": "ex. TPS, TVQ, TVH",
      "rate": "Taux (%)",
      "ratePlaceholder": "ex. 14,975",
      "registrationNumber": "Numéro d'inscription",
      "registrationNumberPlaceholder": "ex. 123456789 RT0001",
      "active": "Active",
      "includeByDefault": "Ajouter automatiquement aux nouvelles soumissions"
    }
  },
  "nav": {
    "operations": "Opérations",
    "sales": "Ventes",
    "salesDesk": "Pipeline",
    "clients": "Clients",
    "resources": "Ressources"
  },
  "catalog": {
    "title": "Catalogue"
  },
  "pipeline": {
    "card": {
      "wonVerbal": "Travaux acceptés — planifier",
      "wonVerbalConfirmTitle": "Travaux acceptés de vive voix ?",
      "wonVerbalToast": "Deal gagné — les travaux sont créés."
    },
    "win": {
      "submit": "Confirmer et planifier",
      "cancelsEvaluation": "L'évaluation en banque sera annulée."
    }
  },
  "salesFlow": {
    "filters": {
      "title": "Filtres"
    },
    "renew": {
      "title": "{label} — qu'est-ce qu'il a dit ?",
      "titlePlain": "Renouveler — qu'est-ce qu'il a dit ?",
      "underpricedHint": "Prix jugé trop bas l'an dernier",
      "plan": {
        "shared": "Renouvelle le forfait {number} : {jobs}",
        "stays": "{label} reste ({reason})",
        "alternative": "+ l'option non choisie {number} revient à côté",
        "alternativeExtras": "+ l'option non choisie {number} (+ {extras}) revient à côté",
        "otherAmount": "Autre montant → Nouveau prix",
        "card": "Forfait · {number}"
      },
      "card": {
        "send": "Même prix",
        "prepare": "Nouveau prix",
        "won": "Vendu au téléphone",
        "reassess": "À réévaluer"
      },
      "hint": {
        "send": "Renvoie la soumission de l'an dernier, à {amount}.",
        "prepare": "Ouvre la soumission de l'an dernier pour refaire le prix.",
        "won": "Le job naît vendu ; sa première visite va en banque.",
        "reassess": "Une évaluation va en banque ; l'ancien prix reste sous la main."
      },
      "landsLabel": "Le job va dans",
      "lands": {
        "send": "Ventes · Soumission non signée",
        "prepare": "Ventes · Soumission à écrire",
        "won": "Banque",
        "reassess": "Banque"
      },
      "amount": "Combien ?",
      "amountHint": "l'an dernier",
      "submit": {
        "send": "Envoyer la soumission",
        "prepare": "Rédiger la soumission",
        "won": "Créer vendu",
        "reassess": "Planifier l'évaluation"
      },
      "toast": {
        "sent": "Soumission envoyée pour {label}",
        "sentNoEmail": "Renouvelé pour {label} — lien émis, aucun courriel au dossier",
        "notPresented": "Renouvelé pour {label} — la soumission n'est pas partie : {reason}",
        "prepared": "Renouvelé pour {label}",
        "won": "Vendu pour {label}",
        "reassess": "Évaluation en banque pour {label}"
      }
    },
    "relance": {
      "title": "Relance — aujourd'hui",
      "placeholder": "Ce que le client a dit (facultatif)",
      "returnOn": "Revoir le",
      "withNote": "{line} — « {note} »"
    },
    "snooze": {
      "control": "Reporter",
      "controlSet": "Reporté au {date}",
      "title": "Reporter ce dossier",
      "tomorrow": "Demain",
      "inThreeDays": "Dans 3 jours",
      "nextMonday": "Lundi prochain",
      "pickDate": "Une date",
      "reason": "Raison (facultative)",
      "submit": "Reporter",
      "lift": "Annuler le report",
      "until": "Reporté au {date}",
      "include": "Inclure les reportés",
      "toastSet": "Reporté au {date}.",
      "toastLifted": "Report annulé.",
      "undo": "Annuler",
      "historySet": "Reporté au {date}",
      "historySetWhy": "Reporté au {date} — {reason}",
      "historyCleared": "Report annulé"
    },
    "page": {
      "sales": "Ventes",
      "renewals": "Renouvellements",
      "payments": "Recouvrement"
    },
    "campaign": {
      "season": "Saison",
      "since": "Clients depuis",
      "progress": {
        "toCall": "{n} à appeler",
        "called": "{n} appelés",
        "renewed": "{n} renouvelés",
        "unreached": "{n} non rappelés",
        "declined": "{n} refus",
        "cohort": "sur {n} clients"
      },
      "end": "Terminer la campagne",
      "endConfirmTitle": "Terminer la campagne {label} ?",
      "endConfirmLine": "Tous les clients ont été rappelés. La liste se vide et le badge disparaît. | {n} client n'a pas été rappelé : il sera marqué « non rappelé » (pas un refus) et reviendra à la prochaine campagne. La liste se vide et le badge disparaît. | {n} clients n'ont pas été rappelés : ils seront marqués « non rappelés » (pas un refus) et reviendront à la prochaine campagne. La liste se vide et le badge disparaît.",
      "ended": "Campagne terminée",
      "noSeason": "Aucune saison ouverte — la campagne commence à l'ouverture de l'année.",
      "lastYearControl": "Dernier job en",
      "all": "Tous",
      "empty": "Personne à appeler.",
      "emptyEnded": "Campagne terminée — plus personne à appeler.",
      "emptyYear": "Personne à appeler dont le dernier job date de {year}.",
      "line": {
        "callBack": "Rappeler le {date}"
      },
      "row": {
        "jobs": "{n} jobs",
        "addresses": "{n} adresse | {n} adresses"
      },
      "card": {
        "to_answer": "À répondre",
        "renewed": "Renouvelé",
        "refused": "Refusé en {year}",
        "declined_year": "Pas en {year}",
        "declined_forever": "Ne plus renouveler",
        "unreached": "Non rappelé en {year}",
        "finishedPartial": "{done} visites sur {total} · dernière le {date}"
      },
      "declineAll": "Tout refuser pour {year}",
      "declineAllTitle": "Tout refuser pour {year} ?",
      "declineAllLine": "{n} job passe à « Pas en {year} ». Il reviendra à la campagne suivante. | {n} jobs passent à « Pas en {year} ». Ils reviendront à la campagne suivante.",
      "snoozeAll": "Tout reporter",
      "snoozeAllTitle": "Reporter tous les jobs à répondre",
      "sinceDefault": "Par défaut (3 ans)",
      "beyondReach": "Seuls les 100 premiers sont affichés — précisez avec la recherche ou « Dernier job en ».",
      "launcher": "Choisissez un client dans la liste, ou commencez par le premier : chaque appel règle tout son dossier.",
      "start": "Commencer les appels",
      "underpriced": "Prix jugé trop bas"
    },
    "reason": {
      "all": "Tous",
      "to_write": "Soumission à écrire",
      "to_assess": "Évaluation à planifier",
      "sent": "Soumission non signée",
      "prepay": "Paiement avant travaux",
      "unpaid": "Facture impayée"
    },
    "reasonLine": {
      "renewalPrefix": "Renouvellement · ",
      "toWrite": "Soumission à écrire · évaluée il y a {n} j",
      "written": "Soumission écrite, pas envoyée · {n} j",
      "toAssess": "Évaluation à planifier · reçue il y a {n} j",
      "toWriteNew": "Soumission à écrire · reçue il y a {n} j",
      "sent": "Soumission non signée · envoyée il y a {n} j",
      "unpaid": "Facture envoyée il y a {n} j",
      "prepayToBill": "À facturer avant les travaux · signée il y a {n} j",
      "prepayAwaiting": "Paiement attendu avant les travaux · facturée il y a {n} j"
    },
    "emptyReason": {
      "to_write": "Personne n'attend une soumission.",
      "to_assess": "Aucune demande en attente.",
      "sent": "Aucune soumission non signée.",
      "unpaid": "Aucune facture impayée.",
      "prepay": "Aucun travail n'attend un paiement."
    },
    "emptyAll": "Rien à faire — tout est à jour.",
    "state": {
      "to_evaluate": "À évaluer",
      "to_write": "À écrire",
      "written": "Écrite, pas envoyée",
      "unpriced": "Écrite, {n} ligne sans prix | Écrite, {n} lignes sans prix"
    },
    "beyondReach": "Seuls les plus anciens sont affichés ici — précisez avec la recherche ou le filtre de type.",
    "noName": "Sans nom",
    "group": {
      "to_renew": "À renouveler",
      "to_contact": "À contacter",
      "to_produce": "À soumissionner",
      "proposals": "Sans réponse",
      "invoices": "Impayées"
    },
    "act": {
      "open_builder": "Rédiger la soumission",
      "renew": "Renouveler",
      "decline_year": "Pas cette année",
      "decline_forever": "Plus jamais",
      "declinedYear": "Pas de renouvellement en {year}.",
      "declinedForever": "Ne sera plus renouvelé.",
      "reconsidered": "Refus annulé.",
      "otherSeasons": "Les autres années",
      "writeFrom": "Rédiger : {offer}",
      "writeBlank": "Document vide",
      "otherOffers": "Les autres offres du type",
      "send_proposal": "Envoyer la soumission",
      "sent": "Soumission envoyée au client.",
      "sentNoEmail": "Soumission prête et lien émis — aucun courriel au dossier.",
      "noEmail": "Aucun courriel au dossier",
      "unpriced": "Ajoutez un prix avant d'envoyer",
      "unpricedLine": "Une ligne n'a pas encore de prix",
      "relance": "Renvoyer par courriel",
      "present": "Rendre accessible au client",
      "presented": "Soumission accessible au client.",
      "confirm_sale": "Confirmer la vente",
      "mark_transmitted": "Marquer comme transmise",
      "revise": "Modifier",
      "deliveredNoted": "Transmission notée.",
      "expiredBlock": "Expirée — prolongez la validité d'abord",
      "mark_paid": "Marquer payée",
      "claim": "Envoyer la facture par courriel",
      "claimMany": "Envoyer les {count} factures par courriel",
      "otherChannels": "Autres moyens d’envoi",
      "sendBySms": "Par texto",
      "soon": "bientôt",
      "extend": "Prolonger la validité",
      "extendUntil": "Jusqu’au {date}",
      "lost": "Marquer comme perdu",
      "copy_link": "Copier le lien client",
      "view_proposal": "Voir la soumission",
      "open_invoice": "Ouvrir la facture",
      "bill": "Facturer",
      "issue_bill": "Émettre la facture",
      "require_payment_first": "Exiger le paiement avant travaux pour ce client",
      "billed": "Facture {number} émise",
      "issuedBill": "Facture émise",
      "requiredPaymentFirst": "{name} paiera avant les travaux à l'avenir",
      "extended": "Validité prolongée de {days} jours.",
      "plan_evaluation": "Planifier l'évaluation",
      "plan_work": "Planifier les travaux",
      "remind": "Marquer comme relancée",
      "reminded": "Relance notée.",
      "remindedParked": "Relance notée — reporté au {date}.",
      "mailedParked": "Courriel envoyé — reporté au {date}."
    },
    "due": {
      "createdAgo": "Reçue aujourd'hui | Reçue hier | Reçue il y a {n} j",
      "renewedAgo": "Renouvelée aujourd'hui | Renouvelée hier | Renouvelée il y a {n} j",
      "openedAgo": "Saison ouverte aujourd'hui | Saison ouverte hier | Saison ouverte il y a {n} j",
      "when": "aujourd'hui | hier | il y a {n} j",
      "doneOn": "fait le {date}",
      "doneOnCap": "Fait le {date}",
      "assessedAgo": "Évaluée aujourd'hui | Évaluée hier | Évaluée il y a {n} j",
      "sentAgo": "Transmise aujourd'hui | Transmise hier | Transmise il y a {n} j",
      "presentedAgo": "Présentée aujourd'hui | Présentée hier | Présentée il y a {n} j",
      "invoicedAgo": "Facturée aujourd'hui | Facturée hier | Facturée il y a {n} j",
      "signedAgo": "Signée aujourd'hui | Signée hier | Signée il y a {n} j",
      "neverReminded": "Jamais relancée",
      "neverClaimed": "Jamais réclamée",
      "remindedAgo": "Relancée aujourd'hui | Relancée hier | Relancée il y a {n} j",
      "claimedAgo": "Réclamée aujourd'hui | Réclamée hier | Réclamée il y a {n} j",
      "expiredShort": "Expirée",
      "age": "{n} j"
    },
    "card": {
      "history": "Historique",
      "renewalOf": "Renouvellement de",
      "close": "Fermer",
      "email": "Courriel",
      "smsSoon": "L'envoi de textos arrive.",
      "noReach": "Aucune coordonnée",
      "noType": "Sans type",
      "addAccess": "Ajouter une note d'accès",
      "addDescription": "Ajouter une description",
      "descriptionDoor": "Description",
      "viewMap": "Voir sur la carte",
      "openDeal": "Ouvrir le dossier",
      "otherDossiers": "Ses autres dossiers",
      "followUp": "Suivi",
      "addFollowUp": "Ajouter un suivi",
      "shrink": "Réduire"
    },
    "paper": {
      "others": "aucun autre document | 1 autre document | {n} autres documents",
      "copyLink": "Copier le lien",
      "viewPdf": "Voir le PDF",
      "expand": "Agrandir",
      "send": "Envoyer",
      "sendThis": "Envoyer {number} par courriel",
      "draft": "Brouillon {number}",
      "notSent": "pas envoyée",
      "unpriced": "{n} ligne sans prix | {n} lignes sans prix",
      "noPrice": "aucun prix",
      "ago": "aujourd’hui | hier | il y a {n} j",
      "channel": {
        "email": "courriel",
        "sms": "texto",
        "manual": "suivi",
        "in_person": "en personne",
        "phone": "téléphone",
        "paper": "papier"
      },
      "proposal": "Soumission",
      "invoice": "Facture"
    },
    "door": {
      "dealGone": "Ce dossier n'est plus ouvert.",
      "workDated": "Les travaux sont déjà planifiés — seule la vente reste à confirmer.",
      "openBuilderPage": "Ouvrir la page complète"
    },
    "start": "Commencer par {name}"
  },
  "records": {
    "jobs": "Jobs",
    "jobsHere": "Jobs à cette adresse",
    "newJob": "Nouveau job",
    "addresses": "{n} adresse | {n} adresses",
    "moreJobs": "Voir l’autre | Voir les {n} autres",
    "note": "Note",
    "addNote": "Ajouter une note",
    "contact": "Client",
    "company": "Entreprise",
    "address": "Adresse"
  },
  "leads": {
    "actions": {
      "create": "Nouveau lead"
    },
    "title": "Leads",
    "searchPlaceholder": "Rechercher un client",
    "filterByState": "État",
    "allStates": "Tous les états",
    "ageDays": "{count} j",
    "fields": {
      "state": "État",
      "value": "Valeur",
      "age": "Âge"
    },
    "tabs": {
      "all": "Tout",
      "active": "Actifs",
      "lost": "Perdus"
    },
    "state": {
      "new": "Rien de commencé",
      "toContact": "À contacter",
      "toPlace": "Entendu — à placer",
      "evaluationBooked": "Évaluation prévue",
      "toQuote": "À soumissionner",
      "sent": "Soumission envoyée",
      "stalled": "Sans suite",
      "lost": "Perdu"
    }
  },
  "filters": {
    "active": "Filtres :",
    "remove": "Retirer {name}",
    "clearAll": "Tout effacer",
    "assignees": "Assignés",
    "types": "Types",
    "seasons": "Saison",
    "noSeason": "Sans saison",
    "noOpenSeason": "Aucune saison ouverte",
    "notRenewed": "Non renouvelés"
  },
  "admin": {
    "title": "Administration",
    "errors": {
      "title": "Erreurs"
    },
    "features": {
      "title": "Fonctionnalités",
      "saved": "Fonctionnalité mise à jour",
      "flippedOn": "Activé",
      "flippedOff": "Désactivé",
      "console": "console",
      "sales_enabled": {
        "label": "Ventes",
        "description": "Désactivé, masque toutes les soumissions et évaluations."
      },
      "weather_enabled": {
        "label": "Météo",
        "description": "Active la Météo."
      },
      "housecall_migration_enabled": {
        "label": "Migration Housecall Pro",
        "description": "Affiche « Migration Housecall Pro » dans Importations, aux administrateurs."
      }
    },
    "goodJob": {
      "title": "GoodJob"
    },
    "organizations": {
      "title": "Organisations",
      "subtitle": "Tous les locataires de la plateforme",
      "new": "Nouvelle organisation",
      "searchPlaceholder": "Rechercher par nom",
      "none": "Aucune organisation",
      "filterAll": "Toutes",
      "filterActive": "Actives",
      "filterSuspended": "Suspendues",
      "statusActive": "Active",
      "statusSuspended": "Suspendue",
      "columns": {
        "name": "Organisation",
        "created": "Créée le",
        "members": "Membres",
        "jobs30d": "Jobs (30 j)",
        "lastActivity": "Dernière activité",
        "status": "Statut"
      }
    },
    "provision": {
      "title": "Nouvelle organisation",
      "orgSection": "Organisation",
      "ownerSection": "Propriétaire",
      "name": "Nom",
      "locale": "Langue",
      "timeZone": "Fuseau horaire",
      "billingEmail": "Courriel de facturation",
      "hqAddress": "Adresse du siège",
      "quebecPack": "Pack Québec",
      "quebecPackHint": "Crée la TPS 5 % + TVQ 9,975 % et l'entrepôt par défaut",
      "ownerEmail": "Courriel",
      "ownerEmailHint": "Un nouveau courriel reçoit une invitation; un compte existant obtient l'accès sans courriel.",
      "ownerFirstName": "Prénom",
      "ownerLastName": "Nom de famille",
      "submit": "Créer l'organisation",
      "successInvited": "Organisation créée — invitation envoyée au propriétaire",
      "successAttached": "Organisation créée — accès accordé au compte existant"
    },
    "detail": {
      "loadError": "Échec du chargement de l'organisation",
      "createdOn": "Créée le {date}",
      "overview": "Aperçu",
      "members": "Membres ({count})",
      "memberActive": "Actif",
      "invitationPending": "Invitation envoyée le {date}",
      "invite": "Inviter un membre",
      "inviteSubmit": "Accorder l'accès",
      "inviteSentSuccess": "Invitation envoyée",
      "accessGrantedSuccess": "Accès accordé",
      "role": "Rôle",
      "resend": "Renvoyer",
      "resendSuccess": "Invitation renvoyée",
      "remove": "Retirer",
      "removeSuccess": "Accès révoqué",
      "removeConfirmTitle": "Révoquer l'accès ?",
      "removeConfirmBody": "{name} perdra immédiatement l'accès à cette organisation.",
      "suspend": "Suspendre",
      "suspendSuccess": "Organisation suspendue",
      "suspendConfirmTitle": "Suspendre cette organisation ?",
      "suspendConfirmBody": "{name} cessera de fonctionner immédiatement — ses membres perdent l'accès jusqu'à sa réactivation.",
      "restore": "Réactiver",
      "restoreSuccess": "Organisation réactivée"
    },
    "roles": {
      "member": "Membre",
      "admin": "Admin",
      "owner": "Propriétaire"
    },
    "notFound": {
      "title": "Page introuvable",
      "body": "Il n'y a rien ici."
    }
  },
  "common": {
    "pdf": {
      "unavailable": "Le PDF n’est pas disponible pour le moment.",
      "retry": "Réessayer",
      "download": "Télécharger le PDF"
    },
    "loadMore": "Afficher plus",
    "home": "Accueil",
    "contacts": "Contacts",
    "jobs": "Travaux",
    "parts": "Catalogue de prix",
    "settings": "Paramètres",
    "theme": {
      "dark": "Thème sombre",
      "light": "Thème clair"
    },
    "light": "Clair",
    "dark": "Sombre",
    "cropImage": "Recadrer l'image",
    "cropImageDescription": "Ajustez votre image pour qu'elle s'adapte parfaitement.",
    "back": "Retour",
    "cancel": "Annuler",
    "apply": "Appliquer",
    "dragToReorder": "Glisser pour réordonner",
    "confirm": "Confirmer",
    "moreActions": "Plus d’actions",
    "create": "Créer",
    "update": "Mettre à jour",
    "edit": "Modifier",
    "view": "Voir",
    "delete": "Supprimer",
    "moveUp": "Monter",
    "moveDown": "Descendre",
    "save": "Enregistrer",
    "add": "Ajouter",
    "done": "Terminé",
    "close": "Fermer",
    "map": "Carte",
    "website": "Site web",
    "more": "Plus",
    "sitePhotos": "Photos du site",
    "addPhoto": "Ajouter une photo",
    "photoUploaded": "Photo téléchargée avec succès.",
    "photoDeleted": "Photo supprimée.",
    "noPhotosCaptured": "Aucune photo capturée pour le moment",
    "noPhotosHint": "Les photos prises sur le terrain par l'équipe apparaîtront ici.",
    "uploadFailed": "Le téléversement a échoué. Réessayez.",
    "deletePhotoTitle": "Supprimer cette photo ?",
    "deletePhotoDescription": "La photo sera retirée du dossier du job. Cette action est définitive.",
    "hello": "Bonjour",
    "technician": "Technicien",
    "clients": "Clients",
    "clientDirectory": "Répertoire des clients.",
    "clientDetails": "Détails du client",
    "call": "Appeler",
    "loadFailed": "Chargement impossible",
    "filters": "Filtres",
    "text": "Texto",
    "reach": "Appeler ou texter",
    "clearSearch": "Effacer la recherche",
    "email": "Courriel",
    "actions": "Actions",
    "timeline": "Chronologie",
    "new": "Nouveau",
    "present": "Présent",
    "exit": "Quitter",
    "comingSoon": "L'intégration du catalogue de prix sera bientôt disponible.",
    "searchPlaceholder": "Rechercher",
    "noItems": "Aucun élément trouvé",
    "noMatches": "Aucun résultat",
    "clearFilters": "Effacer les filtres",
    "endOfList": "Fin de la liste",
    "noResults": "Aucun résultat",
    "loading": "Chargement...",
    "required": "Ce champ est requis",
    "showing": "{from}–{to} sur {total}",
    "previous": "Précédent",
    "next": "Suivant",
    "pageOf": "Page {page} sur {pages}",
    "selectOption": "Sélectionner une option",
    "selectDate": "Choisir une date",
    "selectDateTime": "Choisir date et heure",
    "from": "Du",
    "to": "Au",
    "user": "Utilisateur",
    "unknownUser": "Utilisateur Inconnu",
    "quantity": "Quantité",
    "total": "Total",
    "summary": "Résumé",
    "tryAgain": "Réessayer",
    "somethingWentWrong": "Une erreur est survenue",
    "toHandle": "À traiter",
    "appearance": "Apparence",
    "darkMode": "Mode sombre",
    "switchOrg": "Changer d'organisation",
    "logoutConfirmTitle": "Se déconnecter ?",
    "logoutConfirmBody": "Vous devrez vous reconnecter pour voir votre journée.",
    "active": "Actif",
    "inactive": "Inactif",
    "all": "Tous",
    "none": "Aucun",
    "import": "Importer",
    "companies": "Entreprises",
    "name": "Nom",
    "countries": {
      "CA": "Canada",
      "US": "États-Unis"
    },
    "provinces": {
      "AB": "Alberta",
      "BC": "Colombie-Britannique",
      "MB": "Manitoba",
      "NB": "Nouveau-Brunswick",
      "NL": "Terre-Neuve-et-Labrador",
      "NS": "Nouvelle-Écosse",
      "NT": "Territoires du Nord-Ouest",
      "NU": "Nunavut",
      "ON": "Ontario",
      "PE": "Île-du-Prince-Édouard",
      "QC": "Québec",
      "SK": "Saskatchewan",
      "YT": "Yukon"
    },
    "states": {
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "Californie",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DC": "District de Columbia",
      "DE": "Delaware",
      "FL": "Floride",
      "GA": "Géorgie",
      "HI": "Hawaï",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiane",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "Nouveau-Mexique",
      "NY": "New York",
      "NC": "Caroline du Nord",
      "ND": "Dakota du Nord",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvanie",
      "RI": "Rhode Island",
      "SC": "Caroline du Sud",
      "SD": "Dakota du Sud",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginie",
      "WA": "Washington",
      "WV": "Virginie-Occidentale",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    },
    "sort": {
      "nameAsc": "Nom (A–Z)",
      "nameDesc": "Nom (Z–A)",
      "newest": "Plus récents",
      "oldest": "Plus anciens"
    }
  },
  "validation": {
    "required": "{field} est requis",
    "email": "Adresse courriel invalide",
    "url": "URL invalide",
    "minValue": "Doit être au moins {min}",
    "positiveInteger": "{field} doit être un nombre entier positif",
    "positiveNumber": "{field} doit être supérieur à zéro",
    "rangeOrder": "La valeur la plus tardive ne peut pas précéder la plus tôt",
    "phoneE164": "Numéro de cellulaire invalide (ex. 514 555-0123). Les postes et les notes vont dans le champ Téléphone."
  },
  "more": {
    "title": "Plus",
    "subtitle": "Répertoires et équipe.",
    "companies": "Entreprises",
    "companiesDesc": "Parcourir les clients et partenaires commerciaux.",
    "crew": "Mon équipe",
    "crewDesc": "Les escouades dont vous faites partie et leurs membres."
  },
  "crew": {
    "empty": "Vous ne faites partie d'aucune escouade.",
    "you": "vous",
    "usualTarget": "Vise habituellement {value}"
  },
  "vehicles": {
    "title": "Véhicules",
    "subtitle": "Gérez votre flotte de camions et de fourgonnettes.",
    "addVehicle": "Ajouter un véhicule",
    "addTitle": "Ajouter un véhicule",
    "createSuccess": "Véhicule ajouté.",
    "updateSuccess": "Véhicule mis à jour.",
    "deleteSuccess": "Véhicule supprimé.",
    "deleteConfirmTitle": "Supprimer le véhicule?",
    "deleteConfirmDescription": "Retirer {name} de votre flotte? Cette action est irréversible.",
    "searchPlaceholder": "Rechercher des véhicules",
    "emptyTitle": "Aucun véhicule",
    "tabs": {
      "all": "Tous",
      "active": "Actifs",
      "inactive": "Inactifs"
    },
    "fields": {
      "name": "Nom",
      "namePlaceholder": "ex. Camion 1 — Ford Transit",
      "status": "Statut",
      "active": "Actif"
    }
  },
  "depots": {
    "hqRow": "Siège",
    "hqFallback": "Départ et retour par défaut",
    "title": "Dépôts",
    "addDepot": "Ajouter un dépôt",
    "createNamed": "Ajouter le dépôt « {name} »",
    "addTitle": "Ajouter un dépôt",
    "createSuccess": "Dépôt ajouté.",
    "updateSuccess": "Dépôt mis à jour.",
    "deleteSuccess": "Dépôt retiré.",
    "deleteConfirmTitle": "Retirer le dépôt?",
    "deleteConfirmDescription": "Retirer {name}? Les tournées passées qui l'utilisaient restent inchangées.",
    "emptyTitle": "Aucun dépôt",
    "geocode": {
      "pending": "Localisation…",
      "succeeded": "Localisé",
      "failed": "Introuvable"
    },
    "fields": {
      "name": "Nom",
      "namePlaceholder": "ex. Domicile de Marc",
      "address": "Adresse",
      "addressPlaceholder": "ex. 123 Rue Principale, Québec",
      "location": "Localisation"
    },
    "searchPlaceholder": "Rechercher un dépôt"
  },
  "weather": {
    "conditions": {
      "rain": "Pluie",
      "wind": "Vent",
      "frost": "Gel",
      "heat": "Chaleur"
    },
    "direction": {
      "above": "au-dessus de",
      "below": "en dessous de"
    },
    "errors": {
      "valueRequired": "Indiquez une valeur",
      "outOfRange": "Doit être entre {min} et {max}"
    },
    "settings": {
      "title": "Météo",
      "hint": "Seuils par défaut. Ils ne rendent rien sensible à eux seuls : la sensibilité se déclare sur l'étape ou sur le type de job.",
      "attribution": "Prévisions d'Environnement Canada. Aucune adresse de client n'est transmise."
    },
    "sensitivity": {
      "blankUsesDefault": "Vide = seuil de l'entreprise."
    },
    "type": {
      "title": "Météo par défaut",
      "none": "Aucune"
    },
    "outlook": {
      "title": "Ce matin",
      "notConfigured": "Aucune limite météo n'est définie, donc rien ne peut être signalé.",
      "configureLink": "Définissez-les sur un type de job",
      "noConfirmedDay": "Aucune journée confirmée aujourd'hui.",
      "stops": "{count} arrêt | {count} arrêts",
      "aboveThreshold": "{count} au-dessus du seuil | {count} au-dessus du seuil",
      "clear": "Rien au-dessus d'un seuil",
      "peakRain": "Pluie jusqu'à {value} % à {at}",
      "peakWind": "Vent jusqu'à {value} {unit} à {at} (rafales {gust})",
      "rainScale": "Probabilité de pluie",
      "unknownHour": "aucune prévision",
      "partialCoverage": "Données incomplètes pour une partie de la journée.",
      "unknownHourStops": "{count} arrêt non jugé | {count} arrêts non jugés",
      "showHours": "Voir les heures",
      "hideHours": "Masquer les heures",
      "gustShort": "rafales {value}",
      "noForecastInWindow": "Aucune prévision pour les heures de travail"
    },
    "cell": {
      "chipRisk": "{lop} % dès {from} · {count} à risque",
      "chipRiskNoHour": "{lop} % · {count} à risque",
      "chipQuiet": "{lop} % · {count} à vérifier",
      "chipQuietNoLop": "{count} à vérifier",
      "popoverTitle": "Pluie · {date}",
      "threshold": "seuil des arrêts : {lop} %",
      "verdictAtRisk": "{value} % · seuil {threshold}",
      "verdictAtRiskOther": "au-dessus du seuil",
      "verdictSafe": "correct",
      "verdictUnjudged": "à vérifier",
      "stopAtRisk": "Pluie au-dessus du seuil de cet arrêt"
    },
    "org": {
      "chipConfigure": "Météo à configurer",
      "chipTimeZone": "Fuseau horaire à définir",
      "chipUnavailable": "Météo indisponible",
      "chipNoWindow": "Aucune prévision aux heures ouvrées"
    }
  },
  "maps": {
    "locationTitle": "Emplacement",
    "snapshotAlt": "Carte de l'emplacement",
    "dayOverviewAlt": "Carte des arrêts du jour, numérotés dans l'ordre de la tournée"
  },
  "customers": {
    "customer": "Client",
    "pickPlaceholder": "Chercher un client",
    "newAddress": "Nouvelle adresse",
    "newTitle": "Nouveau client",
    "siteContact": "Personne-ressource",
    "dedup": {
      "geocoding": "Localisation de l'adresse…",
      "placeFound": "On a déjà une adresse ici :",
      "currently": "actuellement {name}",
      "useLocation": "Utiliser ce lieu",
      "newLocation": "Non, nouveau lieu",
      "usingLocation": "Lieu existant : {name}",
      "newLocationConfirmed": "Nouveau lieu confirmé",
      "geocodeFailed": "Adresse non localisée — aucune vérification de doublon",
      "cellFound": "Ce numéro est au dossier de {name}.",
      "itsThem": "C'est {name}",
      "releaseNumber": "Nouveau propriétaire — le retirer de sa fiche",
      "usingContact": "Client existant : {name}",
      "numberReleased": "Le numéro sera transféré de {name} à ce client",
      "change": "changer"
    },
    "optional": "facultatif",
    "kind": {
      "contact": "Particulier",
      "company": "Entreprise"
    }
  },
  "addressLookup": {
    "locating": "Localisation de l'adresse…",
    "weakGrade": "≈ centre du terrain",
    "choose": "{count} adresses correspondent",
    "askStreet": "Précisez la rue : le code postal ne suffit pas pour le {number}",
    "notFound": "Aucune adresse trouvée",
    "createUnlocated": "Créer sans localisation",
    "saveUnlocated": "Enregistrer sans localisation",
    "willCreateUnlocated": "Sera créée sans localisation",
    "willSaveUnlocated": "Sera enregistrée sans localisation",
    "unavailable": "Localisation indisponible pour l'instant",
    "withoutPostal": "Rue et ville",
    "postalOnly": "Code postal seulement",
    "change": "changer",
    "validation": {
      "civicNumberRequired": "Numéro civique requis",
      "postalIncomplete": "Code postal incomplet",
      "cityOrPostalRequired": "Ville ou code postal requis"
    }
  },
  "serviceLocations": {
    "title": "Adresses de service",
    "geocodeFailed": "Échec du géocodage",
    "addLocation": "Ajouter une adresse",
    "editTitle": "Modifier l'adresse",
    "editDescription": "Mettez à jour l'adresse ou les détails de cet emplacement.",
    "createDescription": "Ajoutez une adresse de service pour ce contact.",
    "createSuccess": "Adresse ajoutée.",
    "updateSuccess": "Adresse mise à jour.",
    "deleteSuccess": "Adresse supprimée.",
    "deleteConfirmTitle": "Supprimer l'adresse?",
    "deleteConfirmDescription": "Voulez-vous vraiment supprimer \"{name}\"? Les travaux à cet emplacement ne seront pas affectés.",
    "unnamed": "Adresse sans nom",
    "noLocationsForContact": "Aucune adresse pour ce contact.",
    "navTitle": "Adresses",
    "searchPlaceholder": "Rechercher par client ou par adresse",
    "noLocations": "Aucune adresse.",
    "customer": "Client",
    "noCustomer": "Aucun client",
    "createdOn": "Créée le",
    "company": "Entreprise",
    "noCompany": "Aucune entreprise",
    "noContact": "Aucune personne-ressource",
    "notFound": "Adresse introuvable.",
    "viewRecord": "Voir la fiche",
    "fields": {
      "name": "Nom de l'emplacement",
      "namePlaceholder": "ex. Entrepôt, Unité 4B (optionnel)",
      "address_line1": "Adresse civique",
      "civicNumber": "N° civique",
      "street": "Rue",
      "city": "Ville",
      "province": "Province",
      "state": "État",
      "provinceState": "Province / État",
      "postal_code": "Code postal",
      "country": "Pays",
      "notes": "Notes d'accès",
      "notesPlaceholder": "Code de portail, instructions de stationnement, etc.",
      "siteContact": "Personne-ressource",
      "person": "Personne",
      "noSiteContact": "Aucune"
    },
    "detailsTitle": "Adresse",
    "deleteTitle": "Supprimer l’adresse"
  },
  "invitations": {
    "accept": {
      "title": "Accepter l'invitation",
      "subtitle": "Créez votre compte pour rejoindre votre équipe sur Vitesse.",
      "action": "Créer le compte et se connecter",
      "success": "Bienvenue à bord ! Votre compte a été créé.",
      "invalidToken": "Le lien d'invitation est invalide ou a expiré."
    }
  },
  "errors": {
    "validation": {
      "required": "Ce champ est obligatoire.",
      "email": "Veuillez entrer une adresse courriel valide.",
      "passwordMin": "Le mot de passe doit comporter au moins 8 caractères.",
      "passwordMismatch": "Les mots de passe ne correspondent pas."
    },
    "api": {
      "default": "Une erreur inattendue est survenue. Veuillez réessayer.",
      "unexpected_format": "Le serveur a renvoyé une erreur dans un format inattendu.",
      "LOGIN_FAILED": "Courriel ou mot de passe invalide.",
      "UNAUTHORIZED": "Vous n'êtes pas autorisé à effectuer cette action.",
      "FORBIDDEN": "Vous n'avez pas la permission d'accéder à cette ressource.",
      "RECORD_NOT_UNIQUE": "Cet enregistrement n'a pas pu être sauvegardé car il existe déjà.",
      "SQUAD_VEHICLE_TAKEN": "Ce camion appartient déjà à une autre équipe. Libérez-le d'abord.",
      "VEHICLE_DAY_TAKEN": "Une autre équipe a déjà ce camion ce jour-là.",
      "SQUAD_LEAD_TAKEN": "Une équipe ne peut avoir qu'un seul chef d'équipe.",
      "SQUAD_MEMBER_DUPLICATE": "Cette personne occupe déjà ce rôle avec ce métier dans l'équipe.",
      "NO_TARGET": "Définissez un objectif du jour (ou un défaut sur l'équipe) pour que la proposition sache où s'arrêter.",
      "LANE_OFF": "Mauvaise unité pour cette équipe : une équipe de soumissions se compose en arrêts, une équipe de traitement en $.",
      "NOTHING_TO_PROPOSE": "Rien à proposer — aucun travail en attente ne convient à cette équipe ce jour-là."
    }
  },
  "migrations": {
    "title": "Migration Housecall Pro",
    "answers": {
      "untyped": "Sans type",
      "skip": "Ne pas importer"
    },
    "files": {
      "customers": "Clients",
      "jobs": "Jobs",
      "estimates": "Soumissions",
      "required": "requis",
      "uploading": "Envoi",
      "wrongFile": "Ce fichier n'est pas cet export Housecall",
      "remove": "Retirer le fichier",
      "browse": "Parcourir",
      "verify": "Vérifier",
      "megabytes": "{n} Mo",
      "kilobytes": "{n} Ko"
    },
    "refusals": {
      "customers_file_required": "Le fichier des clients est requis",
      "jobs_or_estimates_required": "Ajoutez les jobs ou les soumissions",
      "open_run": "Une migration est déjà en cours",
      "invalid_state": "Cette migration a changé entre-temps",
      "invalid_answer": "Une réponse ne nomme pas un type de job",
      "scan_failed": "Les fichiers n'ont pas pu être lus",
      "unknown": "La migration n'a pas pu démarrer"
    },
    "types": {
      "search": "Rechercher un service",
      "names": "{n} nom | {n} noms",
      "columns": {
        "name": "Service",
        "rows": "Lignes",
        "year": "Année",
        "answer": "Réponse"
      },
      "selected": "{n} sélectionné | {n} sélectionnés",
      "assignTo": "Assigner à",
      "pickType": "Type de job",
      "blank": "(sans description)",
      "answered": "{n} nom déjà répondu | {n} noms déjà répondus",
      "continue": "Continuer",
      "jobs": "{n} job | {n} jobs",
      "estimates": "{n} soum. | {n} soum.",
      "footer": {
        "rows": "{n} ligne | {n} lignes",
        "types": "{n} type | {n} types",
        "untyped": "{n} sans type",
        "skipped": "{n} non importée | {n} non importées"
      }
    },
    "working": {
      "scanning": "Lecture des services",
      "verifying": "Vérification",
      "writing": "Écriture",
      "stages": {
        "customers": "Clients",
        "jobs": "Jobs",
        "estimates": "Soumissions",
        "seasons": "Saisons"
      },
      "elapsed": "moins d'une minute | {n} min | {n} min"
    },
    "report": {
      "inFlight": "Travaux en cours",
      "toPlan": "{n} job à planifier | {n} jobs à planifier",
      "byType": "Par type",
      "columns": {
        "type": "Type",
        "jobs": "Jobs",
        "billed": "$ facturés",
        "estimates": "Soumissions",
        "quoted": "$ soumis"
      },
      "imported": "Importés",
      "notImported": "Non importés",
      "customersAndEstimates": "Clients et soumissions",
      "customersCreated": "Clients créés",
      "customersUpdated": "Clients mis à jour",
      "customersUnchanged": "Clients inchangés",
      "estimatesMatched": "Soumissions rattachées à leur job",
      "estimatesLost": "Soumissions perdues",
      "estimatesCancelled": "Vendues, jamais facturées → annulées",
      "seasons": "Saisons",
      "seasonsSkipped": "Les années de saison n'ont pas été données : une saison chevauche deux années.",
      "undecided": "Jobs à trancher (type à deux saisons)",
      "yearsClosed": "{n} année fermée | {n} années fermées",
      "yearState": {
        "idle": "{year} non ouverte",
        "open": "{year} ouverte"
      },
      "waiting": "{n} job attend | {n} jobs attendent",
      "notBuiltOn": "Non gérés",
      "unhandledStatus": "Statuts non gérés « {column} »",
      "ignoredColumns": "Colonnes ignorées · {file}",
      "leftAside": "Laissés de côté",
      "aside": {
        "live": "Jobs planifiés après l'export",
        "unresolved": "Identités non résolues",
        "no_address": "Sans adresse",
        "estimates_ambiguous": "Soumissions ambiguës",
        "estimates_on_skipped_job": "Soumissions d'un job non importé",
        "estimates_live": "Soumissions planifiées après l'export",
        "skipped_kept": "Déjà importés, conservés",
        "estimates_in_flight_superseded": "Travaux en cours facturés depuis",
        "estimates_in_flight_worked": "Travaux en cours travaillés ici",
        "estimates_in_flight_aged_worked": "Travaux en cours expirés, travaillés ici",
        "cells_withheld": "Cellulaires retenus",
        "failures": "Échecs"
      },
      "capped": "{shown} premiers sur {total}",
      "changeTypes": "Modifier les types",
      "import": "Importer",
      "filesOf": "Fichiers du {date}"
    },
    "status": {
      "pending": "Lecture",
      "scanning": "Lecture",
      "typing": "Types à répondre",
      "verifying": "Vérification en cours",
      "verified": "Vérifiée",
      "writing": "Écriture en cours",
      "written": "Écrite",
      "failed": "Échec",
      "abandoned": "Abandonnée"
    },
    "failed": {
      "retry": "Relancer l'écriture",
      "staleTemplate": "Un type de job répondu a été supprimé depuis. Répondez de nouveau aux types.",
      "interrupted": "La migration s'est interrompue.",
      "generic": "La migration a échoué."
    },
    "toast": {
      "written": "Migration écrite | Migration écrite · {n} adresse à localiser | Migration écrite · {n} adresses à localiser"
    },
    "section": {
      "title": "Migrations",
      "customers": "Clients",
      "jobs": "Jobs",
      "estimates": "Soumissions"
    }
  },
  "imports": {
    "steps": {
      "upload": "Fichier",
      "mapping": "Colonnes",
      "preview": "Aperçu",
      "result": "Résultat"
    },
    "upload": {
      "templateHint": "Besoin d'un modèle ? Téléchargez le CSV de départ.",
      "downloadTemplate": "Télécharger le modèle",
      "dropzone": "Déposez votre fichier ici, ou cliquez pour parcourir",
      "acceptedFormats": "Accepté : .csv, .xlsx, .xls, .ods",
      "limits": "Maximum {mb} Mo et {rows} lignes",
      "rejectedType": "Ce type de fichier n'est pas accepté. Formats : {formats}",
      "rejectedSize": "Ce fichier dépasse {max} Mo.",
      "uploading": "Téléversement… {pct}%"
    },
    "groups": {
      "contact": "Contact",
      "primaryAddress": "Adresse principale",
      "company": "Entreprise",
      "part": "Article"
    },
    "mapping": {
      "instructions": "Associez chaque colonne de votre fichier au champ correspondant dans Vitesse.",
      "csvColumn": "Colonne du fichier",
      "mapsTo": "Champ Vitesse",
      "sheet": "Onglet",
      "skip": "Ignorer",
      "optional": "optionnel",
      "contested": "Deux champs pointent vers la même colonne : {columns}",
      "ignored": "{count} colonne(s) du fichier ne seront pas importées : {columns}",
      "preview": "Aperçu →"
    },
    "preview": {
      "rowCount": "{count} lignes dans ce fichier",
      "invalidCount": "{count} illisibles",
      "duplicateCount": "{count} lignes correspondent à une fiche existante",
      "matchedBy": "Trouvées par {key}",
      "blankColumns": "{count} colonne(s) sans nom ignorée(s)",
      "renamedColumns": "Colonnes en double renommées : {names}",
      "importButton": "Importer {count} lignes",
      "nothingToWrite": "Rien à écrire avec ces réglages.",
      "actions": {
        "create": "Créer",
        "update": "Mettre à jour",
        "skip": "Ignorer",
        "error": "Erreur"
      },
      "strategies": {
        "skip": "Ignorer",
        "update": "Mettre à jour",
        "create_anyway": "Créer quand même"
      },
      "strategyHints": {
        "skip": "Les fiches existantes ne seront pas touchées.",
        "update": "Les cellules remplies remplacent; une cellule vide n'efface jamais rien.",
        "create_anyway": "Une deuxième fiche sera créée pour chaque correspondance."
      },
      "keys": {
        "email": "courriel",
        "sku": "code d'article",
        "company_name": "nom d'entreprise",
        "in_file": "une autre ligne du même fichier"
      }
    },
    "report": {
      "title": "Rapport d'importation",
      "groups": {
        "failed": "Échouées",
        "skipped": "Ignorées",
        "flagged": "À vérifier"
      },
      "shown": "{shown} lignes affichées sur {total}",
      "row": "Ligne",
      "status": "Résultat",
      "problem": "Problème"
    },
    "examples": {
      "first_name": "Marie",
      "last_name": "Tremblay",
      "email": "marie.tremblay{'@'}exemple.com",
      "phone": "418 555-0123",
      "cell_phone": "418 555-0199",
      "job_title": "Propriétaire",
      "address_line1": "130, rue Wolfe",
      "city": "Lévis",
      "province": "QC",
      "postal_code": "G6V 3Z4",
      "country": "Canada",
      "company_name": "Paysagement Rive-Sud inc.",
      "website": "exemple.com",
      "notes": "Client depuis 2019",
      "name": "Engrais 20-0-5",
      "sku": "ENG-2005",
      "unit_price": "24,99",
      "cost_price": "12,50",
      "unit": "sac",
      "job_template": "Fertilisation",
      "taxable": "oui",
      "description": "Sac de 20 kg"
    },
    "flags": {
      "weak_duplicate": "Pourrait déjà être au dossier",
      "ambiguous_duplicate": "Correspond à plus d'une fiche existante",
      "cell_claimed_elsewhere": "Ce numéro de cellulaire est au dossier d'un autre contact",
      "duplicate": "Déjà au dossier",
      "unknown": "Voir le rapport téléchargé pour le détail"
    },
    "result": {
      "processing": "Importation en cours…",
      "processingNote": "Cela peut prendre un moment. Veuillez patienter.",
      "progress": "{done} sur {total}",
      "safeToClose": "Vous pouvez fermer cette fenêtre — l'importation continue.",
      "done": "Importation terminée",
      "created": "{count} fiches créées",
      "updated": "{count} fiches mises à jour",
      "skipped": "{count} lignes déjà au dossier",
      "flagged": "{count} lignes à vérifier",
      "failed": "{count} lignes en erreur",
      "another": "Importer un autre fichier",
      "resume": "Reprendre",
      "downloadFailed": "Télécharger le rapport",
      "rowLabel": "Ligne {n}",
      "moreErrors": "+{count} autres — voir le rapport",
      "error": "Échec de l'importation",
      "unknownError": "Une erreur inattendue est survenue. Veuillez réessayer.",
      "close": "Terminé"
    },
    "fields": {
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "email": "Courriel",
      "phone": "Téléphone",
      "cell_phone": "Cellulaire",
      "job_title": "Fonction",
      "address_line1": "Adresse",
      "city": "Ville",
      "province": "Province / État",
      "postal_code": "Code postal",
      "country": "Pays",
      "name": "Nom",
      "sku": "UGS",
      "unit_price": "Prix unitaire",
      "cost_price": "Prix coûtant",
      "unit": "Unité",
      "job_template": "Type de job",
      "taxable": "Taxable",
      "description": "Description",
      "company_name": "Nom de l'entreprise",
      "website": "Site web",
      "notes": "Notes"
    },
    "notifications": {
      "done": "Importation {type} terminée — {count} enregistrements créés",
      "failed": "Importation {type} échouée — consultez l'historique pour les détails"
    },
    "history": {
      "title": "Historique des importations",
      "unknownType": "Inconnu",
      "emptyTitle": "Aucune importation",
      "kinds": {
        "contact": "Contacts",
        "company": "Entreprises",
        "part": "Articles"
      },
      "columns": {
        "content": "Contenu",
        "status": "État",
        "date": "Date",
        "created": "Créés",
        "failed": "Erreurs",
        "by": "Par"
      },
      "statuses": {
        "pending_mapping": "En attente",
        "dry_running": "Vérification",
        "processing": "En cours",
        "done": "Terminé",
        "failed": "Échoué"
      }
    },
    "viewHistory": "Voir l'historique des importations",
    "contact": {
      "title": "Importer des contacts"
    },
    "part": {
      "title": "Importer des pièces"
    },
    "company": {
      "title": "Importer des entreprises"
    }
  },
  "notifications": {
    "hub": {
      "title": "Notifications",
      "subtitle": "Choisissez les notifications que vous recevez et où.",
      "updateError": "Impossible de mettre à jour votre préférence de notification.",
      "categories": {
        "my_day": "Ma journée",
        "field": "Terrain",
        "money": "Argent",
        "sales": "Ventes",
        "notes": "Notes",
        "imports": "Importations"
      },
      "channels": {
        "web": "Web",
        "mobile": "Mobile"
      },
      "types": {
        "route_changed": {
          "label": "Journée modifiée",
          "description": "Le bureau a changé votre journée d'aujourd'hui : un arrêt retiré, reporté, annulé, ou la journée reconfirmée"
        },
        "job_complete": {
          "label": "Travaux terminés",
          "description": "L'équipe a terminé la dernière visite d'un job — il reste à facturer"
        },
        "field_dropped": {
          "label": "Arrêts retirés par le terrain",
          "description": "Une équipe a retiré un arrêt promis pour aujourd'hui, vidé ou annulé sa journée — des clients à rappeler"
        },
        "proposal_accepted": {
          "label": "Soumission acceptée",
          "description": "Une soumission a été acceptée"
        },
        "proposal_declined": {
          "label": "Soumission refusée",
          "description": "Une soumission a été refusée"
        },
        "proposal_expired": {
          "label": "Soumissions expirées",
          "description": "Un résumé à l'ouverture : les soumissions envoyées qui ont expiré depuis la veille"
        },
        "import_complete": {
          "label": "Import terminé",
          "description": "Un import que vous avez lancé est terminé"
        },
        "day_cancelled": {
          "label": "Journée annulée",
          "description": "Quand votre journée est annulée (météo, bris, équipe indisponible)"
        },
        "day_unclosed": {
          "label": "Journée à clôturer",
          "description": "En fin de quart, si des arrêts de votre journée n'ont pas de verdict (chef d'équipe)"
        },
        "note_mention": {
          "label": "Mention dans une note",
          "description": "Quelqu'un vous nomme ({'@'}) dans une note"
        },
        "invoice_paid": {
          "label": "Paiement reçu",
          "description": "Un client a payé une facture en ligne"
        },
        "payment_problem": {
          "label": "Problème de paiement",
          "description": "Les paiements en ligne sont suspendus, un prélèvement a échoué ou un paiement n'a pu être enregistré"
        }
      }
    }
  },
  "push": {
    "notification": {
      "fallbackTitle": "Nouvelle notification",
      "view": "Voir"
    }
  },
  "fleet": {
    "title": "Équipes",
    "crewColumn": "Équipe",
    "noTruck": "Aucun camion",
    "lanes": {
      "work": "Travaux",
      "quotes": "Soumissions"
    },
    "crew": {
      "notFound": "Cette équipe n'existe plus.",
      "hours": "Heures",
      "followsOrgHours": "Heures de l'organisation",
      "dayOff": "Congé",
      "composer": "Composeur",
      "fill": "Remplissage",
      "fillAuto": "Automatique",
      "manualOnly": "À la main seulement",
      "breakRead": "pause {minutes} min",
      "sections": {
        "work": "Le travail",
        "day": "La journée"
      },
      "perDay": "par jour",
      "moreTypes": "{count} autre | {count} autre | {count} autres",
      "showLess": "Masquer",
      "removeMember": "Retirer de l'équipe",
      "delete": "Supprimer l'équipe",
      "noTruck": "Aucun camion",
      "searchTrade": "Rechercher un métier"
    },
    "columns": {
      "lane": "Voie",
      "truck": "Camion",
      "members": "Membres",
      "dayTarget": "Objectif du jour",
      "depots": "Dépôts"
    },
    "tabs": {
      "vehicles": "Camions",
      "squads": "Équipes",
      "depots": "Dépôts"
    }
  },
  "invoices": {
    "paidVia": {
      "pickTitle": "Comment {number} a-t-elle été payée ?",
      "confirmTitle": {
        "interac": "Marquer {number} payée par virement Interac ?",
        "cheque": "Marquer {number} payée par chèque ?",
        "cash": "Marquer {number} payée comptant ?",
        "card": "Marquer {number} payée par carte ?",
        "other": "Marquer {number} payée (autre mode de paiement) ?"
      },
      "methods": {
        "interac": "Virement Interac",
        "cheque": "Chèque",
        "cash": "Comptant",
        "card": "Carte",
        "other": "Autre"
      }
    },
    "timeline": {
      "created": "Facture créée",
      "issued": "Facture {number} émise",
      "sentBy": "Facture envoyée par {channel}",
      "reminded": "Relance notée",
      "paid": "Facture {number} payée",
      "uncollectible": "Facture {number} passée en perte",
      "voided": "Facture {number} annulée"
    },
    "title": "Facturation",
    "states": {
      "draft": "Brouillon",
      "issued": "Émise",
      "paid": "Payée",
      "void": "Annulée",
      "uncollectible": "Irrécouvrable"
    },
    "card": {
      "invoiceAction": "Facturer",
      "count": "{n} facture | {n} facture | {n} factures",
      "empty": "Aucune facture pour l'instant.",
      "emptyHint": "Les factures naissent d'une section signée, de la soumission entière ou de lignes libres.",
      "draftTitle": "Brouillon",
      "alreadyBilled": "Déjà facturée",
      "sourceProposal": "Facturer la soumission au complet",
      "sourceProposalFor": "Facturer la soumission au complet ({number})",
      "sourceCustom": "Facture libre",
      "sourceEvaluation": "Évaluation"
    },
    "summary": {
      "proposalsToBill": "Soumission non facturée | {n} soumissions non facturées",
      "awaitingPayment": "{n} facture en attente de paiement | {n} factures en attente de paiement",
      "uncollectible": "{n} facture irrécouvrable | {n} factures irrécouvrables",
      "allPaid": "Tout est facturé et payé"
    },
    "row": {
      "open": "Ouvrir",
      "actionsTitle": "Facture {label}"
    },
    "editor": {
      "frozenOn": "Facture émise le {date} — document gelé",
      "frozen": "Document gelé",
      "title": "Facture {number}",
      "draftTitle": "Brouillon de facture",
      "titleLabel": "Titre",
      "titlePlaceholder": "p. ex. Visite 2 — taille de haies",
      "name": "Description",
      "namePlaceholder": "Description de la ligne",
      "quantity": "Qté",
      "unitPrice": "Prix unitaire",
      "unitTag": "Unité : {unit}",
      "discountTag": "Rabais −{percent} %",
      "taxableShort": "Tx",
      "addLine": "Ajouter une ligne",
      "subtotal": "Sous-total",
      "discount": "Rabais",
      "taxes": "Taxes",
      "total": "Total",
      "needLineHint": "Ajoutez au moins une ligne pour émettre.",
      "nameRequiredHint": "Chaque ligne a besoin d'un nom.",
      "regenerate": "Régénérer le lien",
      "regenerateConfirmTitle": "Régénérer le lien public ?",
      "regenerateConfirmBody": "Tous les liens déjà partagés pour cette facture cesseront de fonctionner. Le courriel et la copie utiliseront le nouveau lien.",
      "issue": "Émettre",
      "issueConfirmTitle": "Émettre la facture ?",
      "issueConfirmBody": "Un numéro sera attribué et la facture ne sera plus modifiable.",
      "markPaid": "Marquer payée",
      "markUncollectible": "Irrécouvrable",
      "markUncollectibleConfirmTitle": "Marquer la facture irrécouvrable ?",
      "markUncollectibleConfirmBody": "La dette passe en perte, mais la facture {number} et son lien restent — un paiement tardif pourra encore la marquer payée.",
      "markPaidConfirmBody": "Le paiement sera inscrit à aujourd'hui.",
      "void": "Annuler la facture",
      "voidConfirmTitle": "Annuler la facture ?",
      "voidConfirmBody": "Le numéro {number} restera brûlé. Une nouvelle facture pourra être émise.",
      "delete": "Supprimer",
      "deleteConfirmTitle": "Supprimer le brouillon ?",
      "deleteConfirmBody": "Ce brouillon sera supprimé définitivement.",
      "issuedOn": "Émise le {date}",
      "paidOn": "Payée le {date}",
      "notFound": "Facture introuvable.",
      "retry": "Réessayer",
      "copyLink": "Copier le lien",
      "sendEmail": "Envoyer par courriel",
      "downloadPdf": "Télécharger le PDF"
    },
    "evaluation": {
      "chip": "Facture d'évaluation",
      "notBilled": "Évaluation non facturée",
      "create": "Facturer l'évaluation ({amount})",
      "freeSigned": "Le client a signé — l'évaluation lui est offerte.",
      "signedWarning": "Le client a signé — l'évaluation lui est offerte. Annulez cette facture ou remboursez-la."
    },
    "toasts": {
      "draftCreated": "Brouillon de facture créé.",
      "issued": "Facture {number} émise.",
      "paid": "Facture marquée payée.",
      "voided": "Facture annulée.",
      "uncollectible": "Facture marquée irrécouvrable.",
      "deleted": "Brouillon supprimé.",
      "linkCopied": "Lien copié.",
      "linkRegenerated": "Nouveau lien créé — tous les liens partagés sont morts.",
      "emailSent": "Facture envoyée par courriel.",
      "pdfUnavailable": "Le PDF n'est pas disponible pour le moment."
    }
  },
  "signaturePad": {
    "signHere": "Signez ici",
    "clear": "Effacer",
    "caption": "Signature du client (doigt ou stylet)"
  },
  "publicProposal": {
    "loading": "Chargement…",
    "greetingName": "Bonjour {name},",
    "intro": "Voici notre soumission. Vous pouvez la réviser et la signer en ligne.",
    "introWithAddress": "Voici notre soumission pour les travaux au {address}. Vous pouvez la réviser et la signer en ligne.",
    "facts": {
      "number": "Soumission",
      "issued": "Émise le",
      "validUntil": "Valide jusqu'au"
    },
    "rbq": "RBQ {number}",
    "footerQuestions": "Des questions ? {phone}",
    "subtotal": "Sous-total",
    "discount": "Rabais",
    "taxes": "Taxes",
    "total": "Total",
    "unnamedItem": "Article",
    "optionalItem": "optionnel",
    "itemsCount": "{n} article | {n} articles",
    "acceptCta": "Accepter et signer",
    "copyNotice": "Une copie PDF vous sera transmise après la signature.",
    "signingTitle": "Confirmer votre acceptation",
    "confirmAmount": "Confirmer — {amount}",
    "legal": "En signant, vous acceptez la soumission {number}.",
    "submitting": "Envoi…",
    "submitError": "Une erreur est survenue — réessayez ou appelez-nous.",
    "signed": {
      "title": "Merci! Votre acceptation est enregistrée.",
      "signedOn": "Signée le {date}",
      "copyLabel": "Votre copie du contrat",
      "copyPreparing": "Votre copie PDF est en préparation…",
      "downloadPdf": "Télécharger le PDF",
      "nextLabel": "Ce qui suit",
      "stepContact": "Nous vous contactons pour planifier les travaux",
      "stepWork": "Les travaux sont réalisés",
      "stepWorkSub": "Aux dates convenues avec vous",
      "signedTag": "Signée",
      "yourDocument": "Votre soumission"
    },
    "revised": {
      "title": "Cette soumission a été révisée",
      "body": "Une nouvelle version est en préparation. Contactez-nous pour l'obtenir."
    },
    "expired": {
      "title": "Cette soumission n'est plus disponible",
      "body": "Contactez-nous pour en recevoir une version à jour."
    },
    "superseded": {
      "title": "Cette soumission a été remplacée",
      "body": "Ces travaux ont été confirmés autrement. Contactez-nous pour toute question."
    },
    "notFound": {
      "title": "Ce lien n'est pas valide",
      "body": "Vérifiez le lien reçu ou contactez-nous."
    },
    "signingDocument": "Soumission « {name} »"
  },
  "members": {
    "title": "Membres",
    "invite": "Inviter un membre",
    "inviteSubmit": "Inviter",
    "empty": "Aucun membre.",
    "you": "vous",
    "invitationPending": "Invitation envoyée le {date}",
    "resend": "Renvoyer l'invitation",
    "revoke": "Retirer l'accès",
    "revokeConfirmTitle": "Retirer l'accès ?",
    "revokeConfirmDescription": "{name} ne pourra plus se connecter à votre organisation. Son historique reste visible.",
    "inviteSentSuccess": "Invitation envoyée.",
    "accessGrantedSuccess": "Accès accordé — cette personne avait déjà un compte.",
    "roleChangedSuccess": "Rôle modifié.",
    "revokeSuccess": "Accès retiré.",
    "resendSuccess": "Invitation renvoyée.",
    "columns": {
      "person": "Personne",
      "role": "Rôle"
    },
    "roles": {
      "member": "Membre",
      "admin": "Administrateur",
      "owner": "Propriétaire"
    },
    "fields": {
      "email": "Courriel",
      "emailHint": "Un compte existant est rattaché sans courriel; un nouveau reçoit une invitation.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "role": "Rôle"
    }
  },
  "closures": {
    "title": "Fermetures",
    "hint": "Les jours où l'entreprise est fermée, peu importe le jour de la semaine. Le composeur les saute; un placement à la main reste possible.",
    "addNew": "Nouvelle fermeture",
    "edit": "Modifier la fermeture",
    "empty": "Aucune fermeture à venir.",
    "emptyHint": "Un jour férié, les vacances de la construction, une journée d'entreprise.",
    "showPast": "Voir les fermetures passées",
    "hidePast": "Masquer les fermetures passées",
    "createSuccess": "Fermeture ajoutée.",
    "updateSuccess": "Fermeture mise à jour.",
    "deleteSuccess": "Fermeture retirée.",
    "deleteConfirmTitle": "Retirer la fermeture ?",
    "deleteConfirmDescription": "« {name} » redevient une journée ouvrable.",
    "fields": {
      "date": "Date",
      "name": "Raison",
      "namePlaceholder": "ex. Noël, Fête nationale, vacances de la construction"
    }
  },
  "workPeriods": {
    "title": "Saisons",
    "empty": {
      "declarable": "Aucune saison — le travail est possible à l'année."
    },
    "addSeason": "Nouvelle saison",
    "edit": "Modifier",
    "editTitle": "Modifier — {name}",
    "page": {
      "closeFirst": "Fermez {label} d'abord",
      "delete": "Supprimer",
      "openedOn": "Ouverte le",
      "closedOn": "Fermée le",
      "composer": "Composeur",
      "composerUntil": "jusqu'au {date}",
      "composerFrom": "à partir du {date}",
      "composerBetween": "du {from} au {until}",
      "composerStopped": "arrêté le {date}",
      "composerNoCeiling": "sans limite",
      "composerClosed": "rien de plus ne sera proposé",
      "jobs": "Jobs",
      "jobsWaiting": "Jobs en attente",
      "unserved": "Visites à livrer",
      "leadsUnsold": "Soumissions non vendues",
      "renewable": "Renouvelables",
      "leadsToTransfer": "Soumissions à renouveler",
      "noRun": "Aucun job n'a encore demandé cette saison."
    },
    "fields": {
      "name": "Nom",
      "opens": "Du",
      "closes": "Au",
      "wrapsYear": "Cette saison chevauche deux années"
    },
    "deleteTitle": "Supprimer cette période ?",
    "deleteHint": "Les types qui y étaient rattachés redeviennent possibles à l'année. Refusé tant qu'une année porte des jobs.",
    "createSuccess": "Période créée",
    "updateSuccess": "Période mise à jour",
    "deleteSuccess": "Période supprimée",
    "months": {
      "1": "janv.",
      "2": "févr.",
      "3": "mars",
      "4": "avr.",
      "5": "mai",
      "6": "juin",
      "7": "juill.",
      "8": "août",
      "9": "sept.",
      "10": "oct.",
      "11": "nov.",
      "12": "déc."
    },
    "errors": {
      "day": "Entre 1 et 31",
      "notADate": "Ce jour n'existe pas dans ce mois"
    },
    "onType": {
      "title": "Saisons",
      "noneDefined": "Aucune saison définie.",
      "defineLink": "En créer une",
      "yearRound": "À l'année",
      "seasons": "Saisons",
      "seasonsHint": "Les saisons dans lesquelles ce type se vend."
    },
    "typeWindows": {
      "work": "Travaux",
      "evaluation": "Évaluations",
      "line": {
        "wholeSeason": "Toute la saison",
        "wholeSeasonAtOpening": "Toute la saison · dates à l'ouverture",
        "wholeSeasonBetween": "Toute la saison · {from} → {until}",
        "wholeSeasonFrom": "Toute la saison · dès le {from}",
        "wholeSeasonUntil": "Toute la saison · jusqu'au {until}",
        "between": "{from} → {until}",
        "from": "dès le {from}",
        "until": "jusqu'au {until}",
        "starts": "Commence le {from}",
        "ended": "Terminé le {until}",
        "empty": "fenêtre vide · rien ne sera proposé"
      },
      "setBy": "fixé par {name} le {date}",
      "popoverTitle": "{name} · {season}",
      "likeLastYear": "Comme en {year}",
      "blankIsSeason": "Vide = comme la saison ({range})",
      "likeSeason": "Comme la saison",
      "saved": "Dates de {name} enregistrées"
    },
    "seasonTypes": {
      "title": "Types de job",
      "none": "Aucun type",
      "add": "Ajouter un type",
      "remove": "Retirer {name}"
    },
    "tags": {
      "open": "Ouverte",
      "ceiling_passed": "Composeur arrêté",
      "idle": "En attente",
      "closed": "Fermée",
      "none": "Aucune"
    },
    "verbs": {
      "openYear": "Ouvrir {label}",
      "reopen": "Rouvrir",
      "close": "Fermer",
      "editWindow": "modifier",
      "openSeason": "Ouvrir la saison {label}",
      "startCampaign": "Lancer la campagne",
      "endCampaign": "Terminer la campagne"
    },
    "year": {
      "campaign": "Campagne",
      "season": "Saison",
      "campaignState": {
        "not_started": "Pas commencée",
        "live": "En cours",
        "ended": "Terminée"
      },
      "campaignLine": {
        "not_started": "Campagne pas commencée",
        "live": "Campagne en cours",
        "ended": "Campagne terminée"
      },
      "seasonState": {
        "idle": "Pas ouverte",
        "open": "Ouverte",
        "ceiling_passed": "Ouverte · composeur arrêté",
        "closed": "Fermée"
      },
      "on": "le {date}",
      "onBy": "le {date} par {who}",
      "toCall": "{n} à rappeler",
      "callList": "Liste d'appels",
      "notNext": "La prochaine campagne est {label}",
      "endFirst": "Terminez la campagne {label} d'abord",
      "noYet": "Aucun job pour cette année."
    },
    "runs": {
      "fields": {
        "year": "Année",
        "closedOn": "Fermée le",
        "composeFrom": "Composer du",
        "composeUntil": "au"
      },
      "openTitle": "Ouvrir {name} {label}",
      "openVerb": "Ouvrir {name} {label}",
      "openSuccess": "Saison {label} ouverte",
      "closeTitle": "Fermer {name} {label} ?",
      "closeSub": "Voici ce que la fermeture change.",
      "closeVerb": "Fermer {name} {label}",
      "closeSuccess": "Saison {label} fermée",
      "closeLeadsRenewed": "{count} soumission passée à {next} | {count} soumissions passées à {next}",
      "closeLeadsLost": "{count} soumission marquée perdue | {count} soumissions marquées perdues",
      "unsoldLeads": {
        "title": "Sa soumission non vendue : | Ses {count} soumissions non vendues :",
        "renew": "Renouveler pour {name} {next}",
        "lose": "Marquer perdue | Marquer perdues",
        "keep": "Laisser sur {name} {label}"
      },
      "nextCampaign": {
        "title": "La campagne {name} {next} :",
        "start": "Commencer maintenant",
        "startCount": "Commencer maintenant ({count} à rappeler)",
        "later": "Plus tard"
      },
      "reopenSuccess": "Saison {label} rouverte",
      "endCampaignSuccess": "Campagne {label} terminée.",
      "startCampaignSuccess": "Campagne {label} lancée.",
      "reopenTitle": "Rouvrir {name} {label} ?",
      "reopenSub": "Voici ce que la réouverture change.",
      "reopenVerb": "Rouvrir {name} {label}",
      "windowTitle": "Composeur — {name} {label}",
      "windowSuccess": "Dates du composeur mises à jour",
      "shorteningWarning": "Raccourcir l'intervalle retire du composeur les arrêts déjà proposés en dehors. Les journées confirmées ne bougent pas.",
      "optional": "facultatif",
      "consequences": {
        "confirmedUntouched": "Les journées déjà confirmées ne bougent pas.",
        "closeUnserved": "{count} visite non livrée est marquée « Saison terminée ». Elle reste due et visible sur son job, mais sort du composeur, du remplissage et des retards. | {count} visites non livrées sont marquées « Saison terminée ». Elles restent dues et visibles sur leurs jobs, mais sortent du composeur, du remplissage et des retards.",
        "closeUncalled": "{count} client jamais rappelé perd sa campagne de renouvellement. | {count} clients jamais rappelés perdent leur campagne de renouvellement.",
        "closeComposer": "Le composeur ne propose plus rien pour {name} {label}.",
        "closeLeadsRenew": "{count} soumission non vendue passe à {name} {next} : elle revient au bureau des ventes à l'ouverture de cette saison. | {count} soumissions non vendues passent à {name} {next} : elles reviennent au bureau des ventes à l'ouverture de cette saison.",
        "closeLeadsLose": "{count} soumission non vendue est marquée perdue. | {count} soumissions non vendues sont marquées perdues.",
        "closeLeadsLosePaper": "{count} d'entre elles a une soumission chez le client : elle meurt avec le dossier. | {count} d'entre elles ont une soumission chez le client : elles meurent avec le dossier.",
        "closeLeadsKeep": "{count} soumission non vendue reste sur {name} {label} et quitte le bureau des ventes ; sa saison se change depuis la page du job. | {count} soumissions non vendues restent sur {name} {label} et quittent le bureau des ventes ; leur saison se change depuis la page du job.",
        "nextOpenable": "{name} {label} pourra être ouverte ensuite, pas avant.",
        "reopenable": "Vous pourrez rouvrir {name} {label} tant que {next} n'est pas ouverte.",
        "reopenUnserved": "{count} visite « Saison terminée » redevient due : elle revient dans le composeur, le remplissage et les retards. | {count} visites « Saison terminée » redeviennent dues : elles reviennent dans le composeur, le remplissage et les retards.",
        "reopenComposer": "Le composeur propose de nouveau pour {name} {label}, dans son intervalle.",
        "reopenComposerStopped": "Le composeur reste arrêté : son intervalle finissait le {date}. Modifiez-le pour le relancer.",
        "reopenLeads": "{count} soumission non vendue de {name} {label} revient au bureau des ventes. | {count} soumissions non vendues de {name} {label} reviennent au bureau des ventes.",
        "reopenBlocksNext": "{name} {next} ne pourra pas être ouverte tant que {label} l'est.",
        "reopenUndo": "Vous pourrez refermer {name} {label}.",
        "closeStartsCampaign": "La campagne de renouvellement {name} {next} commence. {name} {next} reste fermée : rien ne se planifie avant « Ouvrir ».",
        "openStartsCampaign": "La campagne de renouvellement {name} {label} commence aussi."
      }
    }
  }
}
